
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2EYDP", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $e39tT = parcelRequire("e39tT");


var $elyOj = parcelRequire("elyOj");

function $1a78b7e80091176c$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $fFa3V.bind)(window, {
        type: (0, $e39tT.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $fFa3V.bind)(window, {
        type: (0, $e39tT.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $fFa3V.bind)(window, {
        type: (0, $e39tT.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $elyOj.getViewportWidth)() !== initialViewPort.w || (0, $elyOj.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $e39tT.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}
module.exports["attachAbortListeners"] = $1a78b7e80091176c$export$9010aa71841a6887;

});

parcelRegister("e39tT", function(module, exports) {
const $2fd4bed2a879aa78$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};
module.exports["AbortEvent"] = $2fd4bed2a879aa78$export$199edc0307b5587f;

});

parcelRegister("elyOj", function(module, exports) {
function $82c51b218c57a7bd$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $82c51b218c57a7bd$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
module.exports["getViewportWidth"] = $82c51b218c57a7bd$export$a497a1dcb4408212;
module.exports["getViewportHeight"] = $82c51b218c57a7bd$export$4f01c15d21ef9cc6;

});

parcelRegister("hnvzE", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d24112bc99f1e46$export$2e2bcd8739ae039);

var $3rKZf = parcelRequire("3rKZf");


var $iRRvH = parcelRequire("iRRvH");


var $5d24112bc99f1e46$export$2e2bcd8739ae039 = (0, $3rKZf.default);

});

parcelRegister("1haRI", function(module, exports) {
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $a58ecef6d8b05339$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $a58ecef6d8b05339$export$2e2bcd8739ae039 = $a58ecef6d8b05339$var$coinflip;
module.exports["default"] = $a58ecef6d8b05339$export$2e2bcd8739ae039;

});

parcelRegister("53d5Q", function(module, exports) {

var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");

let $2ab671efdff53c35$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $2ab671efdff53c35$var$cachedIsFedrampModerate;
function $2ab671efdff53c35$var$detectIsFedrampModerate() {
    if ($2ab671efdff53c35$var$cachedIsFedrampModerate !== undefined) return $2ab671efdff53c35$var$cachedIsFedrampModerate;
    try {
        $2ab671efdff53c35$var$cachedIsFedrampModerate = (0, $T9xHm.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $2ab671efdff53c35$var$cachedIsFedrampModerate = false;
    }
    return $2ab671efdff53c35$var$cachedIsFedrampModerate;
}
function $2ab671efdff53c35$export$89dc2b6be8cc261() {
    $2ab671efdff53c35$var$cachedIsFedrampModerate = undefined;
}
function $2ab671efdff53c35$export$1133b5e2873baa7a() {
    try {
        return $2ab671efdff53c35$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $2ab671efdff53c35$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $2ab671efdff53c35$export$f9bb3bb330fb9609 = 'fy26.04';
function $2ab671efdff53c35$export$2182e73d31080cbc() {
    return $2ab671efdff53c35$export$f9bb3bb330fb9609;
}
const $2ab671efdff53c35$export$d50dacda7fe6392b = 1000;
function $2ab671efdff53c35$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $2ab671efdff53c35$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $2ab671efdff53c35$var$config = newConfig;
}
function $2ab671efdff53c35$export$44487a86467333c3() {
    return $2ab671efdff53c35$var$config;
}
function $2ab671efdff53c35$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($2ab671efdff53c35$var$detectIsFedrampModerate()) return $2ab671efdff53c35$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $2ab671efdff53c35$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $2ab671efdff53c35$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $2ab671efdff53c35$var$config?.enabled !== false;
}
const $2ab671efdff53c35$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $2ab671efdff53c35$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$2ab671efdff53c35$var$config) return [];
        if ($2ab671efdff53c35$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $2ab671efdff53c35$var$config.vc ?? {};
            if ($2ab671efdff53c35$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $dh538.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($2ab671efdff53c35$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $2ab671efdff53c35$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $2ab671efdff53c35$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $2ab671efdff53c35$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $2ab671efdff53c35$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $2ab671efdff53c35$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $2ab671efdff53c35$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $2ab671efdff53c35$export$2d8f8d64dc343d7b() {
    if (!$2ab671efdff53c35$var$config) return undefined;
    try {
        const stats = $2ab671efdff53c35$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $2ab671efdff53c35$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $2ab671efdff53c35$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $2ab671efdff53c35$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $2ab671efdff53c35$export$48f4e0d964030a96(name, interactionType) {
    return $2ab671efdff53c35$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $2ab671efdff53c35$export$9c69f5a724f05f38(name, interactionType) {
    return $2ab671efdff53c35$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $2ab671efdff53c35$export$1d459f020c06ae34(name, interactionType) {
    return $2ab671efdff53c35$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $2ab671efdff53c35$export$29b9ffb14861a1d(capability) {
    if ((0, $dh538.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const { capability: capabilityRate } = $2ab671efdff53c35$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $2ab671efdff53c35$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$2ab671efdff53c35$var$config) return 0;
        const gotConfig = $2ab671efdff53c35$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $2ab671efdff53c35$export$203bd06a99c66a0d(name, interactionType) {
    return $2ab671efdff53c35$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $2ab671efdff53c35$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $2ab671efdff53c35$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$2ab671efdff53c35$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $2ab671efdff53c35$var$config;
        if (typingMethod != null && $2ab671efdff53c35$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $2ab671efdff53c35$export$2d311b3fd18dcab1() {
    try {
        if (!$2ab671efdff53c35$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $2ab671efdff53c35$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $2ab671efdff53c35$export$4f4649ef27b6f5d6() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $2ab671efdff53c35$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $2ab671efdff53c35$export$b150ddad71c80d77() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $2ab671efdff53c35$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $2ab671efdff53c35$export$3c170167645a0eff() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $2ab671efdff53c35$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $2ab671efdff53c35$export$d6dc9444bd15f70f() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $2ab671efdff53c35$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $2ab671efdff53c35$export$20e8108b8ccdd0bd() {
    try {
        if (!$2ab671efdff53c35$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $2ab671efdff53c35$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $2ab671efdff53c35$export$2a8604960d7d23d9 = 60000;
function $2ab671efdff53c35$export$c681731847989445(ufoName) {
    try {
        if (!$2ab671efdff53c35$var$config) return $2ab671efdff53c35$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $2ab671efdff53c35$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $2ab671efdff53c35$export$2a8604960d7d23d9;
    } catch  {
        return $2ab671efdff53c35$export$2a8604960d7d23d9;
    }
}
module.exports["isFedrampOverrideActive"] = $2ab671efdff53c35$export$1133b5e2873baa7a;
module.exports["DEFAULT_TTVC_REVISION"] = $2ab671efdff53c35$export$f9bb3bb330fb9609;
module.exports["setUFOConfig"] = $2ab671efdff53c35$export$10d6139a8fb42158;
module.exports["getConfig"] = $2ab671efdff53c35$export$44487a86467333c3;
module.exports["getSelectorConfig"] = $2ab671efdff53c35$export$59e1f072477dfb48;
module.exports["isUFOEnabled"] = $2ab671efdff53c35$export$74bdb753f1cf4860;
module.exports["isVCRevisionEnabled"] = $2ab671efdff53c35$export$4babcefc81a3ef0b;
module.exports["getMostRecentVCRevision"] = $2ab671efdff53c35$export$70184d6e2c753893;
module.exports["getReactHydrationStats"] = $2ab671efdff53c35$export$2d8f8d64dc343d7b;
module.exports["getInteractionRate"] = $2ab671efdff53c35$export$9466a8f085fa7d4e;
module.exports["getVCRawDataInteractionRate"] = $2ab671efdff53c35$export$48f4e0d964030a96;
module.exports["shouldUseRawDataThirdPartyBehavior"] = $2ab671efdff53c35$export$9c69f5a724f05f38;
module.exports["getPostInteractionRate"] = $2ab671efdff53c35$export$1d459f020c06ae34;
module.exports["getCapabilityRate"] = $2ab671efdff53c35$export$29b9ffb14861a1d;
module.exports["getExtraInteractionRate"] = $2ab671efdff53c35$export$203bd06a99c66a0d;
module.exports["getAwaitBM3TTIList"] = $2ab671efdff53c35$export$2d311b3fd18dcab1;
module.exports["getUfoNameOverrides"] = $2ab671efdff53c35$export$4f4649ef27b6f5d6;
module.exports["getMinorInteractions"] = $2ab671efdff53c35$export$b150ddad71c80d77;
module.exports["getDoNotAbortActivePressInteraction"] = $2ab671efdff53c35$export$3c170167645a0eff;
module.exports["getDoNotAbortActivePressInteractionOnTransition"] = $2ab671efdff53c35$export$d6dc9444bd15f70f;
module.exports["getFinishInteractionOnTransition"] = $2ab671efdff53c35$export$20e8108b8ccdd0bd;
module.exports["getInteractionTimeout"] = $2ab671efdff53c35$export$c681731847989445;

});

parcelRegister("3AFGg", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $53d5Q = parcelRequire("53d5Q");

function $6914878c06e1c53a$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $6914878c06e1c53a$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/') && (0, $dh538.fg)('platform_ufo_trim_labelstack_trailing_slashes')) name = name.replace(/\/+$/, '');
    return name;
}
function $6914878c06e1c53a$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $6914878c06e1c53a$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $53d5Q.getConfig)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $6914878c06e1c53a$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $6914878c06e1c53a$export$1adbaf5c2363e4ae(label);
            const name = $6914878c06e1c53a$export$3535cd9da4961282(label.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    return {
        r: r
    };
}
function $6914878c06e1c53a$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = $6914878c06e1c53a$export$3535cd9da4961282(l.name);
        if ($6914878c06e1c53a$export$1adbaf5c2363e4ae(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}
function $6914878c06e1c53a$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        const name = $6914878c06e1c53a$export$3535cd9da4961282(l.name);
        if ($6914878c06e1c53a$export$1adbaf5c2363e4ae(l)) return `${name}:segment`;
        return name;
    }).join('/');
}
function $6914878c06e1c53a$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$6914878c06e1c53a$export$1adbaf5c2363e4ae(l) ? l.segmentId : $6914878c06e1c53a$export$3535cd9da4961282(l.name)).join('/');
}
function $6914878c06e1c53a$export$1787b1cd413c7e2(labelStack, startWith) {
    return $6914878c06e1c53a$export$caeee352b541de1f(labelStack).startsWith($6914878c06e1c53a$export$caeee352b541de1f(startWith));
}
function $6914878c06e1c53a$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $6914878c06e1c53a$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: $6914878c06e1c53a$export$3535cd9da4961282(ls.name),
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $6914878c06e1c53a$export$cb3145456a04e238(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = $6914878c06e1c53a$var$getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return $6914878c06e1c53a$export$a0cd72da07c76b4c(labelStack, reactUFOVersion);
}
function $6914878c06e1c53a$export$b70bcfd92c93435e(segments, _interactionType) {
    const config = (0, $53d5Q.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config?.segmentsThreshold;
    return segments.map(({ labelStack: labelStack, ...others })=>{
        const stringifiedLabelStack = $6914878c06e1c53a$export$88f21baa687271f4(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = $6914878c06e1c53a$export$1adbaf5c2363e4ae(ls);
            const name = $6914878c06e1c53a$export$3535cd9da4961282(ls.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push({
                n: name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {},
                ...ls.type ? {
                    t: ls.type
                } : {}
            });
        }
        return {
            ...others,
            labelStack: segmentsInfo
        };
    });
}
module.exports["sanitizeUfoName"] = $6914878c06e1c53a$export$e08487ea3ae92adb;
module.exports["sanitizeLabelStackName"] = $6914878c06e1c53a$export$3535cd9da4961282;
module.exports["isSegmentLabel"] = $6914878c06e1c53a$export$1adbaf5c2363e4ae;
module.exports["buildSegmentTree"] = $6914878c06e1c53a$export$1569bc0edeecbcd8;
module.exports["stringifyLabelStackFully"] = $6914878c06e1c53a$export$caeee352b541de1f;
module.exports["labelStackStartWith"] = $6914878c06e1c53a$export$1787b1cd413c7e2;
module.exports["optimizeLabelStack"] = $6914878c06e1c53a$export$a0cd72da07c76b4c;
module.exports["optimizeLabelStackWithRegistry"] = $6914878c06e1c53a$export$cb3145456a04e238;
module.exports["getOldSegmentsLabelStack"] = $6914878c06e1c53a$export$b70bcfd92c93435e;

});

parcelRegister("lMdlY", function(module, exports) {

var $1DJUt = parcelRequire("1DJUt");

var $gzxUG = parcelRequire("gzxUG");


var $dh538 = parcelRequire("dh538");


var $jiBIT = parcelRequire("jiBIT");

function $42b5f5931b7891aa$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}


const $4dec21a3dc57ba14$var$state = {
    context: null
};
const $4dec21a3dc57ba14$var$traceIdKey = (0, $gzxUG.createContextKey)('traceId');
const $4dec21a3dc57ba14$var$spanIdKey = (0, $gzxUG.createContextKey)('spanId');
const $4dec21a3dc57ba14$var$experienceTypeKey = (0, $gzxUG.createContextKey)('type');
function $4dec21a3dc57ba14$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $4dec21a3dc57ba14$export$f2e521e495a88544(interactionId, experienceType) {
    $4dec21a3dc57ba14$export$a1002be327997103(interactionId.replace(/-/g, ''), $4dec21a3dc57ba14$export$295213bc4d0c54ad(), experienceType);
}
function $4dec21a3dc57ba14$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $dh538.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $gzxUG.ROOT_CONTEXT).setValue($4dec21a3dc57ba14$var$traceIdKey, traceId).setValue($4dec21a3dc57ba14$var$spanIdKey, spanId).setValue($4dec21a3dc57ba14$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $jiBIT.getContextManager)() instanceof (0, $jiBIT.UFOContextManager)) {
            let contextManager = (0, $jiBIT.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $4dec21a3dc57ba14$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $4dec21a3dc57ba14$export$b6ac780db3a3cc77() {
    if ((0, $dh538.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $1DJUt.context).active().getValue($4dec21a3dc57ba14$var$traceIdKey)),
            spanId: String((0, $1DJUt.context).active().getValue($4dec21a3dc57ba14$var$spanIdKey)),
            type: String((0, $1DJUt.context).active().getValue($4dec21a3dc57ba14$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $4dec21a3dc57ba14$var$state.context || undefined;
}
function $4dec21a3dc57ba14$export$17ab21d7be720b() {
    if ((0, $dh538.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $jiBIT.getContextManager)() instanceof (0, $jiBIT.UFOContextManager)) {
            let contextManager = (0, $jiBIT.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $gzxUG.ROOT_CONTEXT));
        }
    } else $4dec21a3dc57ba14$var$state.context = null;
}
function $4dec21a3dc57ba14$export$6e17cce6446848f9(_url) {
    if ($4dec21a3dc57ba14$export$b6ac780db3a3cc77() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = $4dec21a3dc57ba14$export$b6ac780db3a3cc77();
    return (0, $42b5f5931b7891aa$export$1115c5277eb10d5e)(traceId, spanId);
}
function $4dec21a3dc57ba14$export$a1e7396778592551(_url) {
    const traceHeaders = $4dec21a3dc57ba14$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}
module.exports["setInteractionActiveTrace"] = $4dec21a3dc57ba14$export$f2e521e495a88544;
module.exports["setActiveTrace"] = $4dec21a3dc57ba14$export$a1002be327997103;
module.exports["getActiveTrace"] = $4dec21a3dc57ba14$export$b6ac780db3a3cc77;
module.exports["clearActiveTrace"] = $4dec21a3dc57ba14$export$17ab21d7be720b;
module.exports["getActiveTraceHttpRequestHeaders"] = $4dec21a3dc57ba14$export$6e17cce6446848f9;
module.exports["getActiveTraceAsQueryParams"] = $4dec21a3dc57ba14$export$a1e7396778592551;

});

parcelRegister("jiBIT", function(module, exports) {

var $gzxUG = parcelRequire("gzxUG");

/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $c8f63d1e4192892a$var$contextManager;
function $c8f63d1e4192892a$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $c8f63d1e4192892a$var$contextManager = ctxMgr;
}
function $c8f63d1e4192892a$export$831109c9f7727010() {
    return $c8f63d1e4192892a$var$contextManager;
}
class $c8f63d1e4192892a$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $gzxUG.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $gzxUG.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $gzxUG.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $gzxUG.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
     * whether the context manager is enabled or not
     */ this._enabled = false;
        /**
     * Keeps the reference to current context
     */ this._currentContext = (0, $gzxUG.ROOT_CONTEXT);
    }
}
module.exports["setContextManager"] = $c8f63d1e4192892a$export$4a00ab8a5dd9b5cf;
module.exports["getContextManager"] = $c8f63d1e4192892a$export$831109c9f7727010;
module.exports["UFOContextManager"] = $c8f63d1e4192892a$export$dd301b96c16f583d;

});

parcelRegister("9x4nt", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b539692aab07d21$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $90YwQ = parcelRequire("90YwQ");

var $2b539692aab07d21$export$2e2bcd8739ae039 = (0, $90YwQ.default);
function $2b539692aab07d21$export$11bcb6e9af2aca35() {
    return (0, $42omo.useContext)((0, $90YwQ.default));
}
module.exports["useInteractionContext"] = $2b539692aab07d21$export$11bcb6e9af2aca35;

});

parcelRegister("feexy", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2119f5c3d305813e$var$listeners = new Set();
// Observable interaction ID implementation
class $2119f5c3d305813e$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $2119f5c3d305813e$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $2119f5c3d305813e$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $2119f5c3d305813e$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $2119f5c3d305813e$export$3109542b68df9ba1 = $2119f5c3d305813e$var$initializeGlobalDefaultInteractionID();
const $2119f5c3d305813e$export$3e0c3023952f6774 = (listener)=>{
    $2119f5c3d305813e$var$listeners.add(listener);
    return ()=>{
        $2119f5c3d305813e$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $2119f5c3d305813e$var$interactionContext = (0, $42omo.createContext)($2119f5c3d305813e$export$3109542b68df9ba1);
var $2119f5c3d305813e$export$2e2bcd8739ae039 = $2119f5c3d305813e$var$interactionContext;
const $2119f5c3d305813e$export$37bca3107733ac1e = ()=>$2119f5c3d305813e$export$3109542b68df9ba1;
const $2119f5c3d305813e$export$9f6000531b78127e = ()=>$2119f5c3d305813e$export$3109542b68df9ba1;
module.exports["DefaultInteractionID"] = $2119f5c3d305813e$export$3109542b68df9ba1;
module.exports["subscribeToInteractionIdChanges"] = $2119f5c3d305813e$export$3e0c3023952f6774;
module.exports["default"] = $2119f5c3d305813e$export$2e2bcd8739ae039;
module.exports["getInteractionId"] = $2119f5c3d305813e$export$37bca3107733ac1e;

});

parcelRegister("4u5NT", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $dh538 = parcelRequire("dh538");


var $1haRI = parcelRequire("1haRI");


var $bHggO = parcelRequire("bHggO");


var $53d5Q = parcelRequire("53d5Q");


var $28pAQ = parcelRequire("28pAQ");


var $3AFGg = parcelRequire("3AFGg");


var $lMdlY = parcelRequire("lMdlY");


var $g68Gk = parcelRequire("g68Gk");


var $feexy = parcelRequire("feexy");


var $VzzNF = parcelRequire("VzzNF");


var $2DIgf = parcelRequire("2DIgf");

const $06d19b54423b55b9$export$cc97b17ef9aeb088 = new Map();







var $4u5NT = parcelRequire("4u5NT");

class $c8de2c2cf6a8c724$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $2DIgf.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
        return interaction?.type === 'page_load' || interaction?.type === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if (interaction?.type === 'page_load' || interaction?.type === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $4u5NT.remove)(id);
        this.reset();
    }
    reset() {
        this.stopVCObserver();
        if (this.finishedInteraction?.id) (0, $4u5NT.remove)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $4u5NT.remove)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        // Store the finished interaction's VC result
        this.lastInteractionFinishVCResult = void 0;
        this.sinkHandlerFn = ()=>{};
    }
}






var $jJ2Ec = parcelRequire("jJ2Ec");




const $36700964d55365aa$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $36700964d55365aa$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $2DIgf.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $jJ2Ec.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $53d5Q.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = (0, $53d5Q.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $36700964d55365aa$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
     * Basic info about interaction that has just finished
     */ this.lastInteractionFinish = null;
        /**
     * Array of observed react render timings
     */ this.reactProfilerTimings = [];
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        this.lastInteractionFinishVCResult = void 0;
        /**
     * Handler function to process / send the observation data
     */ this.sinkHandlerFn = ()=>{};
    }
}


const $ffef50b38ff136d5$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $ffef50b38ff136d5$export$d8f52e8f804021e8 = new (0, $36700964d55365aa$export$2e2bcd8739ae039)();
const $ffef50b38ff136d5$export$481f88116dc8b7ad = new (0, $c8de2c2cf6a8c724$export$2e2bcd8739ae039)();
const $ffef50b38ff136d5$var$interactionQueue = [];
const $ffef50b38ff136d5$var$segmentCache = new Map();
const $ffef50b38ff136d5$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
let $ffef50b38ff136d5$var$firstSegmentLoadMarked = false;
const $ffef50b38ff136d5$var$segmentObservers = [];
function $ffef50b38ff136d5$export$2b3954d2e8509985() {
    const interactionId = (0, $feexy.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId.current);
}
function $ffef50b38ff136d5$var$isPerformanceTracingEnabled() {
    return (0, $53d5Q.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $ffef50b38ff136d5$var$performanceEventObserver;
const $ffef50b38ff136d5$export$17afbba0f16b4b19 = ()=>{
    $ffef50b38ff136d5$var$performanceEventObserver = $ffef50b38ff136d5$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $ffef50b38ff136d5$export$e6be05b411ce21a6(entry);
    });
    return $ffef50b38ff136d5$var$performanceEventObserver;
};
const $ffef50b38ff136d5$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $ffef50b38ff136d5$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $ffef50b38ff136d5$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $ffef50b38ff136d5$var$addSegmentObserver(observer) {
    $ffef50b38ff136d5$var$segmentObservers.push(observer);
    for (const segmentInfo of $ffef50b38ff136d5$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $ffef50b38ff136d5$var$removeSegmentObserver(observer) {
    const index = $ffef50b38ff136d5$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $ffef50b38ff136d5$var$segmentObservers.splice(index, 1);
}
function $ffef50b38ff136d5$export$cd7f480d6b8286c3(interactionId) {
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).delete(interactionId);
}
function $ffef50b38ff136d5$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $ffef50b38ff136d5$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $ffef50b38ff136d5$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $ffef50b38ff136d5$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing` we use only `label|startTime|duration` — the fields that uniquely
 * identify a network request regardless of which iframe reported it. Excluding `segmentId`
 * from the key is intentional: shared Forge runtime CDN URLs reported by N iframes are
 * genuinely the same resource and should be stored only once (B3).
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $ffef50b38ff136d5$var$buildCrossSegmentDedupKey(entry) {
    if (entry.label === 'resource-timing') {
        // Use the url label + timing fields that uniquely identify the request
        const { label: urlLabel, startTime: startTime, duration: duration } = entry.data;
        return `resource-timing|${urlLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $ffef50b38ff136d5$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null && (0, $dh538.fg)('platform_ufo_3p_segment_timings')) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $ffef50b38ff136d5$var$buildCrossSegmentDedupKey(entry);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $ffef50b38ff136d5$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $ffef50b38ff136d5$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $bHggO.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $ffef50b38ff136d5$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $ffef50b38ff136d5$export$85d1eb835f669bf(interactionId, labelStack, time = performance.now()) {
    if (!(0, $dh538.fg)('platform_mark_ufo_segment_first_load')) return;
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null && !$ffef50b38ff136d5$var$firstSegmentLoadMarked) {
        $ffef50b38ff136d5$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $ffef50b38ff136d5$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $ffef50b38ff136d5$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $ffef50b38ff136d5$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $ffef50b38ff136d5$export$9e04fe1a58571ec(moduleId, timestamp) {
    $ffef50b38ff136d5$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $ffef50b38ff136d5$export$6f228d1fdc911d7(identifier, start, end) {
    $ffef50b38ff136d5$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $ffef50b38ff136d5$var$moduleLoadingRequests = {};
function $ffef50b38ff136d5$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $ffef50b38ff136d5$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $ffef50b38ff136d5$var$labelStackToString(labelStack), name, startTime);
}
function $ffef50b38ff136d5$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $ffef50b38ff136d5$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $dQl1W.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $ffef50b38ff136d5$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($ffef50b38ff136d5$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $ffef50b38ff136d5$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $ffef50b38ff136d5$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $ffef50b38ff136d5$var$removeHoldCriterion(id);
            const currentInteraction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $ffef50b38ff136d5$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($ffef50b38ff136d5$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $ffef50b38ff136d5$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $ffef50b38ff136d5$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $ffef50b38ff136d5$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) $ffef50b38ff136d5$var$ensureExtendedHoldInfo(interaction).push({
        labelStack: labelStack,
        name: name,
        start: start,
        end: end
    });
}
function $ffef50b38ff136d5$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($ffef50b38ff136d5$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $ffef50b38ff136d5$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $ffef50b38ff136d5$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $ffef50b38ff136d5$export$2df109852219d16e(interactionId) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $ffef50b38ff136d5$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $ffef50b38ff136d5$export$9e04fe1a58571ec($ffef50b38ff136d5$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $ffef50b38ff136d5$var$moduleLoadingRequests[info.identifier];
            $ffef50b38ff136d5$export$6f228d1fdc911d7($ffef50b38ff136d5$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $ffef50b38ff136d5$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $ffef50b38ff136d5$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $ffef50b38ff136d5$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $ffef50b38ff136d5$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $ffef50b38ff136d5$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $53d5Q.getConfig)()?.postInteractionLog?.enabled) $ffef50b38ff136d5$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $ffef50b38ff136d5$var$pushToQueue(id, data) {
    $ffef50b38ff136d5$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $ffef50b38ff136d5$var$handleInteraction = $ffef50b38ff136d5$var$pushToQueue;
function $ffef50b38ff136d5$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    const isExplicitlyThirdParty = hold.labelStack.some((label)=>'type' in label && label.type === 'third-party');
    return isExplicitlyThirdParty || interaction.end !== 0 && hold.start > interaction.end && (0, $dh538.fg)('platform_ufo_metric_variants');
}
function $ffef50b38ff136d5$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $ffef50b38ff136d5$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $ffef50b38ff136d5$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (!(0, $dh538.fg)('platform_ufo_metric_variants') || interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$ffef50b38ff136d5$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $ffef50b38ff136d5$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $ffef50b38ff136d5$var$ensureMetricWindows(interaction) {
    if (!(0, $dh538.fg)('platform_ufo_metric_variants')) return;
    if (interaction.end === 0) return;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party'
            ]
        }
    };
    if (interaction.end3p !== undefined) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: interaction.end3p,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
}
function $ffef50b38ff136d5$var$addLifecycleObservation(interaction, observation) {
    if (!(0, $dh538.fg)('platform_ufo_metric_variants')) return;
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $ffef50b38ff136d5$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $ffef50b38ff136d5$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $ffef50b38ff136d5$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $g68Gk.currentFeatureFlagsAccessed));
    (0, $lMdlY.clearActiveTrace)();
    $ffef50b38ff136d5$var$callCleanUpCallbacks(data);
    (0, $VzzNF.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $53d5Q.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $3AFGg.sanitizeUfoName)(data.ufoName);
    if (!(0, $1haRI.default)((0, $53d5Q.getPostInteractionRate)(sanitisedUfoName, data.type))) $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
    if (!(0, $1haRI.default)((0, $53d5Q.getExtraInteractionRate)(sanitisedUfoName, data.type))) $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) $ffef50b38ff136d5$export$cd7f480d6b8286c3(id);
    $ffef50b38ff136d5$export$dbba6cdedab4e68b.id = data.id;
    $ffef50b38ff136d5$export$dbba6cdedab4e68b.type = data.type;
    $ffef50b38ff136d5$export$dbba6cdedab4e68b.timestamp = data.end;
    $ffef50b38ff136d5$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $ffef50b38ff136d5$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if ($ffef50b38ff136d5$export$481f88116dc8b7ad.finishedInteraction?.id !== id) // If this same interaction was not already handled, handle it
        $ffef50b38ff136d5$var$handleInteraction(id, data);
    }
    if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $ffef50b38ff136d5$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$ffef50b38ff136d5$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $ffef50b38ff136d5$export$9e614a29a1ac213e(sinkFn) {
    if ($ffef50b38ff136d5$var$handleInteraction === $ffef50b38ff136d5$var$pushToQueue) {
        $ffef50b38ff136d5$var$handleInteraction = sinkFn;
        $ffef50b38ff136d5$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $ffef50b38ff136d5$var$interactionQueue.length = 0;
    }
}
function $ffef50b38ff136d5$export$8a1ba7bef607358a(sinkFn) {
    $ffef50b38ff136d5$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $ffef50b38ff136d5$var$activeSubmitted = false;
function $ffef50b38ff136d5$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $53d5Q.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $53d5Q.getConfig)()?.postInteractionLog?.enabled) $ffef50b38ff136d5$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $ffef50b38ff136d5$var$activeSubmitted = false;
        };
        const noMoreActive3pHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $ffef50b38ff136d5$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $ffef50b38ff136d5$var$ensureMetricWindows(interaction);
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!$ffef50b38ff136d5$var$activeSubmitted) {
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $ffef50b38ff136d5$var$ensureMetricWindows(interaction);
                    $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $53d5Q.getConfig)()?.extraInteractionMetrics?.enabled) $ffef50b38ff136d5$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((0, $53d5Q.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $53d5Q.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $28pAQ.onSearchPageInteractionComplete)(interactionId, interaction);
                    $ffef50b38ff136d5$var$activeSubmitted = true;
                }
                postInteraction();
            }
            // Send separated third-party event even when feature flag is active
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime || interaction.end
                };
                $ffef50b38ff136d5$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else {
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && $ffef50b38ff136d5$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$ffef50b38ff136d5$var$activeSubmitted) {
                    $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction, endTime);
                    if ((0, $53d5Q.getConfig)()?.extraInteractionMetrics?.enabled) $ffef50b38ff136d5$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((0, $53d5Q.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $53d5Q.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $28pAQ.onSearchPageInteractionComplete)(interactionId, interaction);
                    $ffef50b38ff136d5$var$activeSubmitted = true;
                }
                postInteraction();
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime
                };
                $ffef50b38ff136d5$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        }
    }
}
function $ffef50b38ff136d5$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $ffef50b38ff136d5$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $53d5Q.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $ffef50b38ff136d5$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: interaction.hold3pActive?.size ?? 0
            });
            $ffef50b38ff136d5$var$ensureMetricWindows(interaction);
            $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction, endTime);
            $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
            $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
            $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(interactionId);
            return;
        }
        $ffef50b38ff136d5$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $ffef50b38ff136d5$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (interaction.hold3pActive?.size ?? 0)
        });
        $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction);
        $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
        $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
        $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(interactionId);
    }
}
function $ffef50b38ff136d5$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $53d5Q.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $ffef50b38ff136d5$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $ffef50b38ff136d5$var$ensureMetricWindows(interaction);
            $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction, endTime);
            $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
            $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
            $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(interactionId);
            return;
        }
        $ffef50b38ff136d5$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $ffef50b38ff136d5$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction);
        $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
        $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
        $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(interactionId);
    } else if ((0, $dh538.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
        $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $ffef50b38ff136d5$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    const finishInteractions = (0, $53d5Q.getFinishInteractionOnTransition)();
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $53d5Q.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $ffef50b38ff136d5$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $ffef50b38ff136d5$var$ensureMetricWindows(interaction);
            $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction, endTime);
            $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
            $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
            $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(interactionId);
            return;
        }
        if (!hasFinished) {
            $ffef50b38ff136d5$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $ffef50b38ff136d5$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $ffef50b38ff136d5$var$finishInteraction(interactionId, interaction);
        $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
        $ffef50b38ff136d5$export$d8f52e8f804021e8.stopVCObserver();
        $ffef50b38ff136d5$export$481f88116dc8b7ad.stopAll(interactionId);
    });
}
function $ffef50b38ff136d5$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $ffef50b38ff136d5$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $ffef50b38ff136d5$export$481f88116dc8b7ad.reset();
    $ffef50b38ff136d5$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $53d5Q.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $ffef50b38ff136d5$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $ffef50b38ff136d5$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $1haRI.default)((0, $53d5Q.getCapabilityRate)('feature_flag_access'));
    const config = (0, $53d5Q.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $53d5Q.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $2DIgf.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $g68Gk.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $ffef50b38ff136d5$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $ffef50b38ff136d5$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $g68Gk.currentFeatureFlagsAccessed).clear();
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $ffef50b38ff136d5$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $ffef50b38ff136d5$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $53d5Q.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $ffef50b38ff136d5$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $53d5Q.getConfig)()?.postInteractionLog?.enabled) $ffef50b38ff136d5$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if (config?.extraInteractionMetrics?.enabled) $ffef50b38ff136d5$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $ffef50b38ff136d5$export$4a759336b50e86e3(event) {
    const interaction = $ffef50b38ff136d5$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $ffef50b38ff136d5$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $ffef50b38ff136d5$export$ad216cc25852d44b(apdex) {
    (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $ffef50b38ff136d5$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $ffef50b38ff136d5$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $ffef50b38ff136d5$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $ffef50b38ff136d5$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $ffef50b38ff136d5$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $ffef50b38ff136d5$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($ffef50b38ff136d5$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $ffef50b38ff136d5$export$1c43f9ac826b6462(labelStack) {
    const key = $ffef50b38ff136d5$var$getSegmentCacheKey(labelStack);
    const existingSegment = $ffef50b38ff136d5$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $ffef50b38ff136d5$var$segmentCache.set(key, segmentInfo);
        $ffef50b38ff136d5$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $ffef50b38ff136d5$export$d0365e48b58231c3(labelStack) {
    const key = $ffef50b38ff136d5$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $ffef50b38ff136d5$var$segmentCache.get(key);
    if (segmentInfo) {
        $ffef50b38ff136d5$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
        $ffef50b38ff136d5$export$a2b14406ded37d60.set(cacheKey, ($ffef50b38ff136d5$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $ffef50b38ff136d5$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $ffef50b38ff136d5$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $06d19b54423b55b9$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($ffef50b38ff136d5$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $ffef50b38ff136d5$export$6ce04c7ca6810a7e = [];
const $ffef50b38ff136d5$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $ffef50b38ff136d5$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $ffef50b38ff136d5$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $ffef50b38ff136d5$export$6ce04c7ca6810a7e.push(customSpan);
}
module.exports["PreviousInteractionLog"] = $ffef50b38ff136d5$export$dbba6cdedab4e68b;
module.exports["postInteractionLog"] = $ffef50b38ff136d5$export$d8f52e8f804021e8;
module.exports["interactionExtraMetrics"] = $ffef50b38ff136d5$export$481f88116dc8b7ad;
module.exports["segmentUnmountCache"] = $ffef50b38ff136d5$export$a2b14406ded37d60;
module.exports["getActiveInteraction"] = $ffef50b38ff136d5$export$2b3954d2e8509985;
module.exports["remove"] = $ffef50b38ff136d5$export$cd7f480d6b8286c3;
module.exports["updatePageLoadInteractionName"] = $ffef50b38ff136d5$export$f6f1cf5bedf83c71;
module.exports["addCustomData"] = $ffef50b38ff136d5$export$e4380431c2bdabee;
module.exports["addSegmentExtraData"] = $ffef50b38ff136d5$export$35723c3772fda7dd;
module.exports["addIframeSegmentData"] = $ffef50b38ff136d5$export$c227d812a1e08d80;
module.exports["addCohortingCustomData"] = $ffef50b38ff136d5$export$20265b12c6625451;
module.exports["addCustomTiming"] = $ffef50b38ff136d5$export$27cacb7d7f3fe20a;
module.exports["addMark"] = $ffef50b38ff136d5$export$728e28c22a0fba4;
module.exports["markFirstSegmentLoad"] = $ffef50b38ff136d5$export$85d1eb835f669bf;
module.exports["addSpan"] = $ffef50b38ff136d5$export$2c1d6e17cfa9bbc7;
module.exports["addSpanToAll"] = $ffef50b38ff136d5$export$943a8b2b5d6b1809;
module.exports["addHold"] = $ffef50b38ff136d5$export$7606887303596f82;
module.exports["addHoldByID"] = $ffef50b38ff136d5$export$10582acd678c213;
module.exports["addCompletedHold"] = $ffef50b38ff136d5$export$d6cf9650acfb0dab;
module.exports["removeHoldByID"] = $ffef50b38ff136d5$export$4983dfbbb996f7ae;
module.exports["getCurrentInteractionType"] = $ffef50b38ff136d5$export$2df109852219d16e;
module.exports["addError"] = $ffef50b38ff136d5$export$239c33984d9b1367;
module.exports["addErrorToAll"] = $ffef50b38ff136d5$export$7379c15afd3840fa;
module.exports["addProfilerTimings"] = $ffef50b38ff136d5$export$53d6f611de951a13;
module.exports["sinkInteractionHandler"] = $ffef50b38ff136d5$export$9e614a29a1ac213e;
module.exports["sinkPostInteractionLogHandler"] = $ffef50b38ff136d5$export$8a1ba7bef607358a;
module.exports["tryComplete"] = $ffef50b38ff136d5$export$673be905888f8839;
module.exports["abort"] = $ffef50b38ff136d5$export$5def58af4fd46132;
module.exports["abortByNewInteraction"] = $ffef50b38ff136d5$export$c4a545284f55edf2;
module.exports["abortAll"] = $ffef50b38ff136d5$export$614a7af2affc5dff;
module.exports["addOnCancelCallback"] = $ffef50b38ff136d5$export$7b9261a96cfe427b;
module.exports["addNewInteraction"] = $ffef50b38ff136d5$export$1a1ed1e1fdb2006b;
module.exports["addBrowserMetricEvent"] = $ffef50b38ff136d5$export$4a759336b50e86e3;
module.exports["addApdex"] = $ffef50b38ff136d5$export$35220fd6cdd1b731;
module.exports["addRequestInfo"] = $ffef50b38ff136d5$export$57d55b4569823d8f;
module.exports["addSegment"] = $ffef50b38ff136d5$export$1c43f9ac826b6462;
module.exports["removeSegment"] = $ffef50b38ff136d5$export$d0365e48b58231c3;
module.exports["interactionSpans"] = $ffef50b38ff136d5$export$6ce04c7ca6810a7e;
module.exports["addCustomSpans"] = $ffef50b38ff136d5$export$5342dcad19138a1c;

});

parcelRegister("bHggO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $f0d8dc6876d7b97b$export$4c07c8a3507ce307 = 255;
const $f0d8dc6876d7b97b$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $f0d8dc6876d7b97b$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $f0d8dc6876d7b97b$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams?.get(param)));
    } catch  {
        return false;
    }
}
function $f0d8dc6876d7b97b$export$23e69abaca7d0236(name) {
    if (name.length <= $f0d8dc6876d7b97b$export$4c07c8a3507ce307) return name;
    if ($f0d8dc6876d7b97b$var$isGqlUrl(name) && (0, $dh538.fg)('platform_ufo_exclude_gql_timings_from_length_trim')) return name;
    return name.slice(0, $f0d8dc6876d7b97b$export$4c07c8a3507ce307);
}
module.exports["sanitizeTimingName"] = $f0d8dc6876d7b97b$export$23e69abaca7d0236;

});

parcelRegister("28pAQ", function(module, exports) {
const $06e423dcf818c47a$var$interactionBuffer = [];
let $06e423dcf818c47a$var$bufferInteractionData = (interactionId, data)=>{
    $06e423dcf818c47a$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $06e423dcf818c47a$var$clearInteractionBuffer() {
    $06e423dcf818c47a$var$interactionBuffer.length = 0;
}
function $06e423dcf818c47a$var$appendInteractionData(interactionId, data) {
    $06e423dcf818c47a$var$bufferInteractionData(interactionId, data);
}
function $06e423dcf818c47a$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $06e423dcf818c47a$var$interactionBuffer)handler(interactionId, data);
    $06e423dcf818c47a$var$clearInteractionBuffer();
    $06e423dcf818c47a$var$bufferInteractionData = handler;
}
function $06e423dcf818c47a$export$e6a07a94f3e112d4(sinkFn) {
    $06e423dcf818c47a$var$installInteractionSink(sinkFn);
}
function $06e423dcf818c47a$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $06e423dcf818c47a$var$appendInteractionData(interactionId, data);
        $06e423dcf818c47a$var$clearInteractionBuffer();
    }
}
module.exports["sinkExtraSearchPageInteractionHandler"] = $06e423dcf818c47a$export$e6a07a94f3e112d4;
module.exports["onSearchPageInteractionComplete"] = $06e423dcf818c47a$export$74b9ce7e9d206a8;

});

parcelRegister("g68Gk", function(module, exports) {

var $liN2H = parcelRequire("liN2H");

const $537d0f3cd5aa6a0a$export$5b78c989c8db2561 = new Map();
const $537d0f3cd5aa6a0a$export$2a5c8df26bb89760 = new Map();
function $537d0f3cd5aa6a0a$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $liN2H.redactValue)(featureFlagValue);
    $537d0f3cd5aa6a0a$export$5b78c989c8db2561.set(featureFlagName, value);
    $537d0f3cd5aa6a0a$export$2a5c8df26bb89760.set(featureFlagName, value);
}
module.exports["allFeatureFlagsAccessed"] = $537d0f3cd5aa6a0a$export$5b78c989c8db2561;
module.exports["currentFeatureFlagsAccessed"] = $537d0f3cd5aa6a0a$export$2a5c8df26bb89760;
module.exports["addFeatureFlagAccessed"] = $537d0f3cd5aa6a0a$export$47fade9662f71000;

});

parcelRegister("2DIgf", function(module, exports) {

var $53d5Q = parcelRequire("53d5Q");

class $28512cdc9c8c0bdd$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}



var $dh538 = parcelRequire("dh538");





var $4u5NT = parcelRequire("4u5NT");


var $2EYDP = parcelRequire("2EYDP");

function $33ed54be14546eef$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}






var $jJ2Ec = parcelRequire("jJ2Ec");

const $e9d251734418be78$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $e9d251734418be78$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $e9d251734418be78$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $e9d251734418be78$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $e9d251734418be78$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $e9d251734418be78$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $jJ2Ec.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $e9d251734418be78$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $e9d251734418be78$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}



var $elyOj = parcelRequire("elyOj");





var $IkgpF = parcelRequire("IkgpF");


var $10BiY = parcelRequire("10BiY");


var $hZubt = parcelRequire("hZubt");


var $dV52u = parcelRequire("dV52u");

const $326b3a610770232c$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $326b3a610770232c$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $326b3a610770232c$export$b65d046240060e78 {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $326b3a610770232c$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $326b3a610770232c$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $326b3a610770232c$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $326b3a610770232c$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $326b3a610770232c$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $326b3a610770232c$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $IkgpF.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $10BiY.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $IkgpF.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$326b3a610770232c$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $hZubt.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssrPlaceholderHandler = void 0;
        this.ssr = {
            state: $326b3a610770232c$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $53d5Q.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $dV52u.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
}


const $04f37cea0d8299f4$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $04f37cea0d8299f4$var$UNUSED_SECTOR = 0;
function $04f37cea0d8299f4$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $04f37cea0d8299f4$export$1f70d263701b1d01 {
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $04f37cea0d8299f4$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $04f37cea0d8299f4$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $04f37cea0d8299f4$var$UNUSED_SECTOR && ssrTime !== $04f37cea0d8299f4$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $04f37cea0d8299f4$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $04f37cea0d8299f4$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $04f37cea0d8299f4$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $04f37cea0d8299f4$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $04f37cea0d8299f4$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($04f37cea0d8299f4$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $elyOj.getViewportWidth)();
        this.viewport.h = (0, $elyOj.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.heatmap = void 0;
        this.heatmapNext = void 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this.observers = void 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.devToolsEnabled = void 0;
        this.oldDomUpdatesEnabled = void 0;
        this.unbind = [];
        this.isPostInteraction = void 0;
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $04f37cea0d8299f4$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $04f37cea0d8299f4$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $04f37cea0d8299f4$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $33ed54be14546eef$export$72e6dda9d5859230)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $33ed54be14546eef$export$72e6dda9d5859230)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $e9d251734418be78$export$5c86a34c9becd6d0)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $04f37cea0d8299f4$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $04f37cea0d8299f4$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $53d5Q.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $dh538.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $4u5NT.getActiveInteraction)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($04f37cea0d8299f4$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $2EYDP.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $326b3a610770232c$export$b65d046240060e78)({
            selectorConfig: (0, $53d5Q.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $53d5Q.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ $04f37cea0d8299f4$export$1f70d263701b1d01.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];



var $63V9f = parcelRequire("63V9f");








var $kyRHQ = parcelRequire("kyRHQ");

class $9ea2b504429cafec$export$4a1fe1ab3c13bbf5 {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
        (0, $hZubt.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $53d5Q.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $53d5Q.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        });
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
    constructor(opts = {}){
        this.oldVCObserver = void 0;
        this.newVCObserver = void 0;
        this.ssrPlaceholderHandler = void 0;
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $dV52u.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $63V9f.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $53d5Q.isVCRevisionEnabled)('fy25.01') || (0, $53d5Q.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $04f37cea0d8299f4$export$1f70d263701b1d01)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
}
// Some products set this variable to indicate it is running in SSR
let $9ea2b504429cafec$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $9ea2b504429cafec$var$isReactSSR = typeof $kyRHQ !== 'undefined' && Boolean($kyRHQ?.env?.REACT_SSR || false);
function $9ea2b504429cafec$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($9ea2b504429cafec$var$isReactSSR || $9ea2b504429cafec$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $9ea2b504429cafec$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$9ea2b504429cafec$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $28512cdc9c8c0bdd$export$24d07287b49da906)() : new $9ea2b504429cafec$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $9ea2b504429cafec$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$9ea2b504429cafec$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $28512cdc9c8c0bdd$export$24d07287b49da906)() : new $9ea2b504429cafec$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}
module.exports["VCObserverWrapper"] = $9ea2b504429cafec$export$4a1fe1ab3c13bbf5;
module.exports["getVCObserver"] = $9ea2b504429cafec$export$b3bc47985717b49e;
module.exports["newVCObserver"] = $9ea2b504429cafec$export$c69731bddfc24d85;

});

parcelRegister("jJ2Ec", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");

const $b3ecb6ba1f66206b$var$timings = [];
let $b3ecb6ba1f66206b$var$wasHiddenFlag;
let $b3ecb6ba1f66206b$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $b3ecb6ba1f66206b$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $b3ecb6ba1f66206b$var$openedInBackground = null;
function $b3ecb6ba1f66206b$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $b3ecb6ba1f66206b$var$SIZE = 50;
let $b3ecb6ba1f66206b$var$insertIndex = 0;
function $b3ecb6ba1f66206b$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $b3ecb6ba1f66206b$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $b3ecb6ba1f66206b$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $b3ecb6ba1f66206b$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $b3ecb6ba1f66206b$var$openedInBackground === true;
}
function $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag, time) {
    $b3ecb6ba1f66206b$var$timings[$b3ecb6ba1f66206b$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $b3ecb6ba1f66206b$var$insertIndex = ($b3ecb6ba1f66206b$var$insertIndex + 1) % $b3ecb6ba1f66206b$var$SIZE;
    $b3ecb6ba1f66206b$var$wasHiddenFlag = isPageHiddenFlag;
}
function $b3ecb6ba1f66206b$var$handleChange() {
    const isPageHiddenFlag = $b3ecb6ba1f66206b$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$b3ecb6ba1f66206b$var$wasHiddenFlag) $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag);
        $b3ecb6ba1f66206b$var$wasHiddenFlag = true;
    } else {
        if ($b3ecb6ba1f66206b$var$wasHiddenFlag) $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag);
        $b3ecb6ba1f66206b$var$wasHiddenFlag = false;
    }
}
let $b3ecb6ba1f66206b$var$hasHiddenTimingBeforeSetup = false;
function $b3ecb6ba1f66206b$export$95f048bd8bcdda23() {
    return $b3ecb6ba1f66206b$var$hasHiddenTimingBeforeSetup;
}
function $b3ecb6ba1f66206b$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $dh538.fg)('platform_ufo_use_native_page_visibility_api')) $b3ecb6ba1f66206b$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $b3ecb6ba1f66206b$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $fFa3V.bind)(window, {
        type: 'pageshow',
        listener: $b3ecb6ba1f66206b$var$handleChange
    });
    (0, $fFa3V.bind)(window, {
        type: 'pagehide',
        listener: $b3ecb6ba1f66206b$var$handleChange
    });
    (0, $fFa3V.bind)(document, {
        type: 'visibilitychange',
        listener: $b3ecb6ba1f66206b$var$handleChange
    });
}
function $b3ecb6ba1f66206b$export$554cefe0f0373da4() {
    if (!$b3ecb6ba1f66206b$var$setupFlag) {
        const isPageHiddenFlag = $b3ecb6ba1f66206b$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($b3ecb6ba1f66206b$var$openedInBackground === null) $b3ecb6ba1f66206b$var$openedInBackground = isPageHiddenFlag && setupTime < $b3ecb6ba1f66206b$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $b3ecb6ba1f66206b$var$pushHidden(isPageHiddenFlag, 0);
        $b3ecb6ba1f66206b$var$setup();
        $b3ecb6ba1f66206b$var$setupFlag = true;
    }
}
function $b3ecb6ba1f66206b$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($b3ecb6ba1f66206b$var$timings.length === 0) return 'visible';
    const currentSize = $b3ecb6ba1f66206b$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $b3ecb6ba1f66206b$var$insertIndex;
    let endIdx = $b3ecb6ba1f66206b$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($b3ecb6ba1f66206b$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($b3ecb6ba1f66206b$var$timings[tmpIdx] && $b3ecb6ba1f66206b$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($b3ecb6ba1f66206b$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $b3ecb6ba1f66206b$var$timings[startIdx]) hiddenState = $b3ecb6ba1f66206b$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $b3ecb6ba1f66206b$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $b3ecb6ba1f66206b$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $b3ecb6ba1f66206b$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $b3ecb6ba1f66206b$var$throttleMeasurements = [];
let $b3ecb6ba1f66206b$var$throttleInsertIndex = 0;
let $b3ecb6ba1f66206b$var$throttleIntervalId = null;
let $b3ecb6ba1f66206b$var$lastThrottleCheckTime = null;
let $b3ecb6ba1f66206b$var$throttleSetupDone = false;
function $b3ecb6ba1f66206b$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $b3ecb6ba1f66206b$var$THROTTLE_DRIFT_THRESHOLD;
    $b3ecb6ba1f66206b$var$throttleMeasurements[$b3ecb6ba1f66206b$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $b3ecb6ba1f66206b$var$throttleInsertIndex = ($b3ecb6ba1f66206b$var$throttleInsertIndex + 1) % $b3ecb6ba1f66206b$var$THROTTLE_BUFFER_SIZE;
}
function $b3ecb6ba1f66206b$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($b3ecb6ba1f66206b$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $b3ecb6ba1f66206b$var$lastThrottleCheckTime;
        $b3ecb6ba1f66206b$var$recordThrottleMeasurement($b3ecb6ba1f66206b$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $b3ecb6ba1f66206b$var$lastThrottleCheckTime = currentTime;
}
function $b3ecb6ba1f66206b$export$fa0d29a9c87052da() {
    if ($b3ecb6ba1f66206b$var$throttleSetupDone) return;
    $b3ecb6ba1f66206b$var$throttleSetupDone = true;
    // Record the initial timestamp
    $b3ecb6ba1f66206b$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $b3ecb6ba1f66206b$var$throttleIntervalId = setInterval($b3ecb6ba1f66206b$var$throttleCheckCallback, $b3ecb6ba1f66206b$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $b3ecb6ba1f66206b$export$3279694d66e4a1() {
    if ($b3ecb6ba1f66206b$var$throttleIntervalId !== null) {
        clearInterval($b3ecb6ba1f66206b$var$throttleIntervalId);
        $b3ecb6ba1f66206b$var$throttleIntervalId = null;
    }
    $b3ecb6ba1f66206b$var$lastThrottleCheckTime = null;
    $b3ecb6ba1f66206b$var$throttleSetupDone = false;
    $b3ecb6ba1f66206b$var$throttleMeasurements.length = 0;
    $b3ecb6ba1f66206b$var$throttleInsertIndex = 0;
}
function $b3ecb6ba1f66206b$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($b3ecb6ba1f66206b$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $b3ecb6ba1f66206b$var$throttleMeasurements.length; i++){
        const measurement = $b3ecb6ba1f66206b$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $b3ecb6ba1f66206b$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $b3ecb6ba1f66206b$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $b3ecb6ba1f66206b$export$9332de935653b687(measurement) {
    $b3ecb6ba1f66206b$var$throttleMeasurements[$b3ecb6ba1f66206b$var$throttleInsertIndex] = measurement;
    $b3ecb6ba1f66206b$var$throttleInsertIndex = ($b3ecb6ba1f66206b$var$throttleInsertIndex + 1) % $b3ecb6ba1f66206b$var$THROTTLE_BUFFER_SIZE;
}
function $b3ecb6ba1f66206b$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($b3ecb6ba1f66206b$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $b3ecb6ba1f66206b$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($b3ecb6ba1f66206b$var$insertIndex + i) % currentSize;
        const entry = $b3ecb6ba1f66206b$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($b3ecb6ba1f66206b$var$insertIndex + i) % currentSize;
        const entry = $b3ecb6ba1f66206b$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $b3ecb6ba1f66206b$export$9332de935653b687
};
module.exports["getEarliestHiddenTiming"] = $b3ecb6ba1f66206b$export$754443ce7c615bd7;
module.exports["isOpenedInBackground"] = $b3ecb6ba1f66206b$export$21a1a62a307062f1;
module.exports["getHasHiddenTimingBeforeSetup"] = $b3ecb6ba1f66206b$export$95f048bd8bcdda23;
module.exports["setupHiddenTimingCapture"] = $b3ecb6ba1f66206b$export$554cefe0f0373da4;
module.exports["getPageVisibilityState"] = $b3ecb6ba1f66206b$export$768b2008623433e1;
module.exports["setupThrottleDetection"] = $b3ecb6ba1f66206b$export$fa0d29a9c87052da;
module.exports["isTabThrottled"] = $b3ecb6ba1f66206b$export$62a28c860277b3bf;
module.exports["getPageVisibilityTimeline"] = $b3ecb6ba1f66206b$export$5a06b84e47ad70d9;

});

parcelRegister("gxsT9", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $544e044791cfaa0b$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $544e044791cfaa0b$export$7028e9efe569888c = {
    [$544e044791cfaa0b$export$7674290405cc25b0]: true
};
function $544e044791cfaa0b$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", $544e044791cfaa0b$export$7028e9efe569888c, children);
}
module.exports["MEDIA_WRAPPER_TAG"] = $544e044791cfaa0b$export$7674290405cc25b0;
module.exports["VcMediaWrapperProps"] = $544e044791cfaa0b$export$7028e9efe569888c;

});

parcelRegister("63V9f", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $53d5Q = parcelRequire("53d5Q");


var $3AFGg = parcelRequire("3AFGg");


var $4u5NT = parcelRequire("4u5NT");


var $dV52u = parcelRequire("dV52u");

class $54c4326969eba852$export$2e2bcd8739ae039 {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = void 0;
        this.sortedEntriesCache = void 0;
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}


const $51929824de558c61$var$nameCache = new WeakMap();
function $51929824de558c61$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $51929824de558c61$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $51929824de558c61$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $51929824de558c61$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $51929824de558c61$var$nameCache.set(element, name);
    return name;
}
var $51929824de558c61$export$2e2bcd8739ae039 = $51929824de558c61$var$getElementName;






var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");

const $cd3dd2421473eb61$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};


const $adddba8918f1637b$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $adddba8918f1637b$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $adddba8918f1637b$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $adddba8918f1637b$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $adddba8918f1637b$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $adddba8918f1637b$var$parseStyleSet(oldValue);
    const newStyles = $adddba8918f1637b$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$adddba8918f1637b$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$adddba8918f1637b$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $adddba8918f1637b$export$2e2bcd8739ae039 = $adddba8918f1637b$export$e20e7bf2c822f3df;





// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $6a072dc24a59f4c9$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $6a072dc24a59f4c9$export$2e2bcd8739ae039 = $6a072dc24a59f4c9$var$taskYield;


class $570b96390c1c1394$export$3e59ac9de7402fb1 {
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $570b96390c1c1394$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $570b96390c1c1394$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $570b96390c1c1394$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ this.canvas = void 0;
        /** The 2D rendering context of the canvas */ this.ctx = void 0;
        /** Scale factor applied to the canvas (affects final pixel counts) */ this.scaleFactor = void 0;
        /** Maps unique colors to their corresponding timestamps */ this.colorTimeMap = void 0;
        /** Counter used to generate unique colors */ this.colorCounter = void 0;
        this.scaledWidth = void 0;
        this.scaledHeight = void 0;
        this.scaleX = void 0;
        this.scaleY = void 0;
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}
function $570b96390c1c1394$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $570b96390c1c1394$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $6a072dc24a59f4c9$export$2e2bcd8739ae039)();
    }
    return arr;
}


async function $6e0ea22d2e325cd7$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $570b96390c1c1394$export$3e59ac9de7402fb1)(viewport, (0, $dh538.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $6e0ea22d2e325cd7$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $6e0ea22d2e325cd7$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $570b96390c1c1394$export$3e59ac9de7402fb1)(viewport, (0, $dh538.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $6e0ea22d2e325cd7$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $6e0ea22d2e325cd7$export$2e2bcd8739ae039 = $6e0ea22d2e325cd7$var$calculateTTVCPercentiles;
function $6e0ea22d2e325cd7$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $6e0ea22d2e325cd7$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}


const $d50584d7893876df$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $d50584d7893876df$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $d50584d7893876df$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $d50584d7893876df$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $d50584d7893876df$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $d50584d7893876df$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $d50584d7893876df$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $d50584d7893876df$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $d50584d7893876df$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};


function $b5e65b64cb72b81f$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $b5e65b64cb72b81f$export$2e2bcd8739ae039 = $b5e65b64cb72b81f$var$getViewportHeight;


function $cb9a40762bd3d01e$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $cb9a40762bd3d01e$export$2e2bcd8739ae039 = $cb9a40762bd3d01e$var$getViewportWidth;


function $743f36b544f5c8c4$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $743f36b544f5c8c4$export$2e2bcd8739ae039 = $743f36b544f5c8c4$var$isViewportEntryData;


// Helper function for reporting ratios
function $8455fa3262740b78$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $8455fa3262740b78$export$2e2bcd8739ae039 {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $cb9a40762bd3d01e$export$2e2bcd8739ae039)();
        const viewportHeight = (0, $b5e65b64cb72b81f$export$2e2bcd8739ae039)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $8455fa3262740b78$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $743f36b544f5c8c4$export$2e2bcd8739ae039)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $6e0ea22d2e325cd7$export$96ea73435089b05a)({
            viewport: {
                width: (0, $cb9a40762bd3d01e$export$2e2bcd8739ae039)(),
                height: (0, $b5e65b64cb72b81f$export$2e2bcd8739ae039)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $d50584d7893876df$export$93ce39b765ea2cd3)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
    constructor(revisionNo){
        this.revisionNo = void 0;
        this.revisionNo = revisionNo;
    }
}


// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $3ead0c06e71c7341$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id'
];
const $3ead0c06e71c7341$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $3ead0c06e71c7341$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $3ead0c06e71c7341$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $3ead0c06e71c7341$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];



const $c4e44337be132e66$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $c4e44337be132e66$var$REVISION_NO = 'fy25.03';
const $c4e44337be132e66$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $c4e44337be132e66$export$2e2bcd8739ae039 extends (0, $8455fa3262740b78$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$c4e44337be132e66$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $dh538.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $cd3dd2421473eb61$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $cd3dd2421473eb61$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $adddba8918f1637b$export$7867ddcf372cd2bf)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $3ead0c06e71c7341$export$98812f4e79596e2b).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $3ead0c06e71c7341$export$44331555a87fcd9e).includes(attributeName) || (0, $3ead0c06e71c7341$export$c4351da6279bef53).includes(attributeName) && (0, $dh538.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $3ead0c06e71c7341$export$5a7b359ee5e32a5b).includes(attributeName) && (0, $dh538.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $3ead0c06e71c7341$export$2492353b2cc31cc0).includes(attributeName) && (0, $dh538.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $743f36b544f5c8c4$export$2e2bcd8739ae039)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($c4e44337be132e66$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(revisionNo){
        super(revisionNo ?? $c4e44337be132e66$var$REVISION_NO);
    }
}







const $0e97bc44df2fb288$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $0e97bc44df2fb288$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $0e97bc44df2fb288$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $0e97bc44df2fb288$export$2e2bcd8739ae039 extends (0, $c4e44337be132e66$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$0e97bc44df2fb288$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $0e97bc44df2fb288$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $dh538.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $3ead0c06e71c7341$export$c4351da6279bef53),
            ...(0, $dh538.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $3ead0c06e71c7341$export$5a7b359ee5e32a5b) : [],
            ...(0, $dh538.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $3ead0c06e71c7341$export$2492353b2cc31cc0) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $3ead0c06e71c7341$export$98812f4e79596e2b).includes(attributeName) || (0, $3ead0c06e71c7341$export$44331555a87fcd9e).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $0e97bc44df2fb288$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
}





const $6e9f7634ca4a59a9$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $6e9f7634ca4a59a9$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $6e9f7634ca4a59a9$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $6e9f7634ca4a59a9$export$2e2bcd8739ae039 extends (0, $0e97bc44df2fb288$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$6e9f7634ca4a59a9$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $6e9f7634ca4a59a9$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($6e9f7634ca4a59a9$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(){
        super('next');
    }
}






var $jJ2Ec = parcelRequire("jJ2Ec");



const $b73b84aeb7a3081b$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $b73b84aeb7a3081b$var$MAX_OBSERVATIONS = 200;
const $b73b84aeb7a3081b$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $b73b84aeb7a3081b$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $b73b84aeb7a3081b$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $b73b84aeb7a3081b$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($b73b84aeb7a3081b$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $jJ2Ec.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $cb9a40762bd3d01e$export$2e2bcd8739ae039)(),
                h: (0, $b5e65b64cb72b81f$export$2e2bcd8739ae039)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $b73b84aeb7a3081b$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $b73b84aeb7a3081b$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $b73b84aeb7a3081b$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$b73b84aeb7a3081b$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $b73b84aeb7a3081b$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $b73b84aeb7a3081b$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$b73b84aeb7a3081b$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$b73b84aeb7a3081b$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $53d5Q.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $cb9a40762bd3d01e$export$2e2bcd8739ae039)(),
                h: (0, $b5e65b64cb72b81f$export$2e2bcd8739ae039)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}






var $IkgpF = parcelRequire("IkgpF");



var $10BiY = parcelRequire("10BiY");

/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $b80405f8cff42002$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $b80405f8cff42002$export$846396c2d8be3710 = 'data-drop-target-for-';
function $b80405f8cff42002$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($b80405f8cff42002$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($b80405f8cff42002$export$846396c2d8be3710)) return true;
    return false;
}



var $hZubt = parcelRequire("hZubt");

function $263b767207c6958a$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}


function $3599442dd1fcaa0d$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $3599442dd1fcaa0d$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $263b767207c6958a$export$80d6b07c2266a1c6)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$3599442dd1fcaa0d$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}



function $cdfa95ab5931774e$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $cd3dd2421473eb61$export$9db1624a8af791a4)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
					"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
					I think it might have been something along the lines that for consistency every setAttribute call should create a record.
					Conceptually there is after all a mutation: there is an old value replaced with a new one,
					and whether or not they are the same doesn't really matter.
					And Custom elements should work the same way as MutationObserver."
					https://github.com/whatwg/dom/issues/520#issuecomment-336574796
				*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $cdfa95ab5931774e$export$2e2bcd8739ae039 = $cdfa95ab5931774e$var$createMutationObserver;


// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $a239136ea775ec9b$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $a239136ea775ec9b$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $a239136ea775ec9b$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $a239136ea775ec9b$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $a239136ea775ec9b$export$2e2bcd8739ae039 = $a239136ea775ec9b$var$createPerformanceObserver;






var $1haRI = parcelRequire("1haRI");

// Helper function to extract component name from fiber
function $c2737df209b21aa3$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}


function $100bba85714933e4$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $c2737df209b21aa3$export$2e2bcd8739ae039)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $100bba85714933e4$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}


// Helper function to find React fiber on an element
function $402cebb9f4e8d63b$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}


function $70d78f1b94349c00$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache?.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $402cebb9f4e8d63b$export$2e2bcd8739ae039)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}


const $2f8f9717b6f70235$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $2f8f9717b6f70235$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $2f8f9717b6f70235$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $2f8f9717b6f70235$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
// Cache cleanup
let $2f8f9717b6f70235$var$callCount = 0;
const $2f8f9717b6f70235$var$CLEANUP_THRESHOLD = 50;
function $2f8f9717b6f70235$var$maybeCleanup(resultCache) {
    $2f8f9717b6f70235$var$callCount++;
    if ($2f8f9717b6f70235$var$callCount >= $2f8f9717b6f70235$var$CLEANUP_THRESHOLD && (0, $1haRI.default)(0.3)) $2f8f9717b6f70235$export$6a35c3789c327630(resultCache);
}
function $2f8f9717b6f70235$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $2f8f9717b6f70235$var$callCount = 0;
    return resultCache;
}
function $2f8f9717b6f70235$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $2f8f9717b6f70235$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $dh538.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $2f8f9717b6f70235$var$NEW_DOM_WALK_MAX_LEVEL : $2f8f9717b6f70235$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $2f8f9717b6f70235$var$NEW_FIBER_WALK_MAX_LEVEL : $2f8f9717b6f70235$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $70d78f1b94349c00$export$2e2bcd8739ae039)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $100bba85714933e4$export$2e2bcd8739ae039)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}



var $hTKp4 = parcelRequire("hTKp4");

function $73228d9d2ff1eaf4$export$16c2770458939f21(node) {
    const doc = (0, $hTKp4.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}


function $ea84ab244384f5dd$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}


/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $bf7a2427e7e6e7a3$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $bf7a2427e7e6e7a3$export$2e2bcd8739ae039(element.parentElement);
}


// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $99721e7a7968b708$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}


const $c8dbb4acf088c696$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $c8dbb4acf088c696$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $c8dbb4acf088c696$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $c8dbb4acf088c696$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $c8dbb4acf088c696$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $c8dbb4acf088c696$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $78c01d947d12931c$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $78c01d947d12931c$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $78c01d947d12931c$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $78c01d947d12931c$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $ca01fd40e56693af$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $bf7a2427e7e6e7a3$export$2e2bcd8739ae039)(target)) return 'mutation:remount';
        if ((0, $IkgpF.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $bf7a2427e7e6e7a3$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $hZubt.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $c8dbb4acf088c696$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $ca01fd40e56693af$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $bf7a2427e7e6e7a3$export$2e2bcd8739ae039)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $IkgpF.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $bf7a2427e7e6e7a3$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $hZubt.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $c8dbb4acf088c696$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $ca01fd40e56693af$export$2e2bcd8739ae039 {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $3599442dd1fcaa0d$export$c3799d33e0ae80a5)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $cdfa95ab5931774e$export$2e2bcd8739ae039)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $a239136ea775ec9b$export$2e2bcd8739ae039)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $2f8f9717b6f70235$export$6a35c3789c327630)(this.mapIs3pResult);
    }
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.performanceObserver = void 0;
        this.mapVisibleNodeRects = void 0;
        this.mapIs3pResult = void 0;
        this.onChange = void 0;
        this.isStarted = void 0;
        this.trackLayoutShiftOffenders = void 0;
        this.searchPageConfig = void 0;
        // SSR context functions
        this.getSSRState = void 0;
        this.getSSRPlaceholderHandler = void 0;
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $ea84ab244384f5dd$export$e989c0fffaa6b27a)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $2f8f9717b6f70235$export$2e2bcd8739ae039)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $73228d9d2ff1eaf4$export$16c2770458939f21)(addedNode));
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $ca01fd40e56693af$var$createElementMutationsWatcherNew : $ca01fd40e56693af$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $IkgpF.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $2f8f9717b6f70235$export$2e2bcd8739ae039)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $73228d9d2ff1eaf4$export$16c2770458939f21)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $adddba8918f1637b$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $10BiY.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $b80405f8cff42002$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $dh538.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $99721e7a7968b708$export$80a5724ceedcfd3d)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $hZubt.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $78c01d947d12931c$export$597b41700f7dcd36)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $c8dbb4acf088c696$export$fde63bc968551821)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
}



var $fFa3V = parcelRequire("fFa3V");

class $4cacec3838b48fe2$export$2e2bcd8739ae039 {
    bindEvent(type) {
        const unbindCallback = (0, $fFa3V.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $fFa3V.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = void 0;
        this.onEvent = opts.onEvent;
    }
}


const $723ea224b58449b0$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $723ea224b58449b0$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
let $723ea224b58449b0$var$hasAbortingEventDuringSSR = false;
function $723ea224b58449b0$export$88af4849fcc5bbc9() {
    return $723ea224b58449b0$var$hasAbortingEventDuringSSR;
}
class $723ea224b58449b0$export$2e2bcd8739ae039 {
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $723ea224b58449b0$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        if ((0, $dh538.fg)('ufo_fix_aborting_interaction_detection_during_ssr')) {
            this.entriesTimeline.clear();
            if (window?.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') this.entriesTimeline.push({
                        time: time,
                        data: {
                            type: 'window:event',
                            eventType: key
                        }
                    });
                });
            }
            this.windowEventObserver?.start();
        } else {
            if (window?.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') {
                        this.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                        if ((0, $dh538.fg)('ufo_detect_aborting_interaction_during_ssr')) $723ea224b58449b0$var$hasAbortingEventDuringSSR = true;
                    }
                });
            }
            this.windowEventObserver?.start();
            this.entriesTimeline.clear();
        }
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $723ea224b58449b0$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $b5e65b64cb72b81f$export$2e2bcd8739ae039)(),
                    width: (0, $cb9a40762bd3d01e$export$2e2bcd8739ae039)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $b5e65b64cb72b81f$export$2e2bcd8739ae039)(),
                    right: (0, $cb9a40762bd3d01e$export$2e2bcd8739ae039)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeRawData: includeRawData, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $c4e44337be132e66$export$2e2bcd8739ae039)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $53d5Q.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $0e97bc44df2fb288$export$2e2bcd8739ae039)();
        const calculator_next = new (0, $6e9f7634ca4a59a9$export$2e2bcd8739ae039)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $53d5Q.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $53d5Q.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data when fy26.04 is not in the client config so the server
        // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
        const shouldIncludeRawData = includeRawData || !isFy2604Enabled || (0, $dh538.fg)('platform_ufo_always_emit_raw_handler');
        if (shouldIncludeRawData) {
            const rawVCCalculationStartTime = performance.now();
            const rawHandler = new (0, $b73b84aeb7a3081b$export$2e2bcd8739ae039)();
            // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
            const rawStopTime = rawDataStopTime ?? stop;
            const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: rawStopTime
            }) : orderedEntries;
            const raw = await rawHandler.getRawData({
                entries: rawOrderedEntries,
                startTime: start,
                stopTime: rawStopTime,
                isPageVisible: isPageVisible
            });
            results.forEach((result)=>{
                delete result.vcDetails;
                delete result.ratios;
            });
            if (raw) {
                raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                results.push(raw);
            }
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $51929824de558c61$export$2e2bcd8739ae039)(this.selectorConfig, element);
    }
    constructor(config){
        this.selectorConfig = void 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = void 0;
        this.isPostInteraction = void 0;
        this.trackLayoutShiftOffenders = void 0;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $723ea224b58449b0$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $54c4326969eba852$export$2e2bcd8739ae039)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $53d5Q.getSelectorConfig)(config.selectorConfig, $723ea224b58449b0$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $723ea224b58449b0$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $dV52u.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $ca01fd40e56693af$export$2e2bcd8739ae039)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $723ea224b58449b0$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $4cacec3838b48fe2$export$2e2bcd8739ae039)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $dh538.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $4u5NT.getActiveInteraction)();
                    if (interaction?.type === 'press') return;
                }
                const abortEventTargetElement = $723ea224b58449b0$var$isAbortEventTargetSupported(type) && event ? $723ea224b58449b0$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
}
function $723ea224b58449b0$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $723ea224b58449b0$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $3AFGg.sanitizeLabelStackName)(label.name)).join('/');
}
function $723ea224b58449b0$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $3AFGg.sanitizeLabelStackName)(label.name)).join('/');
}
function $723ea224b58449b0$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $723ea224b58449b0$var$labelStackFromFiber(currentFiber);
                labelStackString = $723ea224b58449b0$var$labelStackToString(labelStack) || 'unknown';
                segment = $723ea224b58449b0$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $723ea224b58449b0$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $723ea224b58449b0$var$traverseFiber(fiber) : null;
}
const $723ea224b58449b0$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $723ea224b58449b0$var$isAbortEventTargetSupported(type) {
    return $723ea224b58449b0$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $723ea224b58449b0$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}
module.exports["getHasAbortingEventDuringSSR"] = $723ea224b58449b0$export$88af4849fcc5bbc9;
module.exports["default"] = $723ea224b58449b0$export$2e2bcd8739ae039;

});

parcelRegister("ic4nn", function(module, exports) {
// The UFORouteName object is a global singleton
const $e6b5134df6eb19c4$var$UFORouteName = {
    current: null
};
var $e6b5134df6eb19c4$export$2e2bcd8739ae039 = $e6b5134df6eb19c4$var$UFORouteName;
module.exports["default"] = $e6b5134df6eb19c4$export$2e2bcd8739ae039;

});

parcelRegister("iRRvH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");


var $atuQf = parcelRequire("atuQf");


var $7jr5Y = parcelRequire("7jr5Y");

const $b6cbc78016fd4110$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
// Accepted source values from forge-cdn bridge:
//   - 'forge-framework' (PR #775+) — Forge runtime assets (bridge.js, iframeResizer*, etc.)
//   - 'forge-app'       (PR #775+) — app-author assets on installation-scoped subdomain
//   - 'external'        (both schemes) — anything outside Atlassian-controlled domains
//   - 'internal'        (PR #769 only, LEGACY) — bridges still emit this until PR #775
//                       rolls out everywhere; safe to remove from this allowlist after
//                       the rollout has been stable for a release cycle. Do NOT remove
//                       'external' during that cleanup — it's a first-class value in
//                       both the old and new schemes.
const $b6cbc78016fd4110$var$ACCEPTED_SOURCES = [
    'forge-framework',
    'forge-app',
    'external',
    'internal'
];
function $b6cbc78016fd4110$export$545c2c69328f5019(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    // Trim long URLs to just the last path segment to keep payload size manageable.
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const label = rawName.includes('/') ? rawName.split('/').filter(Boolean).pop() ?? rawName : rawName;
    return {
        label: label,
        // From Resource Timing spec
        redirectStart: $b6cbc78016fd4110$var$num(timing.redirectStart),
        redirectEnd: $b6cbc78016fd4110$var$num(timing.redirectEnd),
        fetchStart: $b6cbc78016fd4110$var$num(timing.fetchStart),
        domainLookupStart: $b6cbc78016fd4110$var$num(timing.domainLookupStart),
        domainLookupEnd: $b6cbc78016fd4110$var$num(timing.domainLookupEnd),
        connectStart: $b6cbc78016fd4110$var$num(timing.connectStart),
        connectEnd: $b6cbc78016fd4110$var$num(timing.connectEnd),
        secureConnectionStart: $b6cbc78016fd4110$var$num(timing.secureConnectionStart),
        requestStart: $b6cbc78016fd4110$var$num(timing.requestStart),
        responseStart: $b6cbc78016fd4110$var$num(timing.responseStart),
        responseEnd: $b6cbc78016fd4110$var$num(timing.responseEnd),
        // Added in PR #769 — present in new flat shape, absent in old nested shape (defaults to 0)
        encodedBodySize: $b6cbc78016fd4110$var$num(timing.encodedBodySize),
        decodedBodySize: $b6cbc78016fd4110$var$num(timing.decodedBodySize),
        transferSize: $b6cbc78016fd4110$var$num(timing.transferSize),
        // From Navigation Timing 2 spec
        redirectCount: $b6cbc78016fd4110$var$num(payload.redirectCount),
        type: typeof payload.type === 'string' ? payload.type : undefined,
        unloadEventStart: $b6cbc78016fd4110$var$num(timing.unloadEventStart),
        unloadEventEnd: $b6cbc78016fd4110$var$num(timing.unloadEventEnd),
        workerStart: $b6cbc78016fd4110$var$num(timing.workerStart),
        nextHopProtocol: typeof timing.nextHopProtocol === 'string' ? timing.nextHopProtocol : undefined
    };
}
function $b6cbc78016fd4110$export$58bcddf582fad063(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const name = rawName.includes('/') ? rawName.split('/').filter(Boolean).pop() ?? rawName : rawName;
    const initiatorType = typeof payload.initiatorType === 'string' ? payload.initiatorType : 'other';
    const startTime = $b6cbc78016fd4110$var$num(payload.startTime);
    const duration = $b6cbc78016fd4110$var$num(payload.duration);
    const fetchStart = $b6cbc78016fd4110$var$num(timing.fetchStart);
    const workerStart = $b6cbc78016fd4110$var$num(timing.workerStart);
    const responseStart = $b6cbc78016fd4110$var$num(timing.responseStart);
    const requestStart = $b6cbc78016fd4110$var$num(timing.requestStart);
    const transferSize = typeof payload.transferSize === 'number' ? payload.transferSize : undefined;
    const encodedSize = typeof payload.encodedBodySize === 'number' ? payload.encodedBodySize : undefined;
    const decodedSize = typeof payload.decodedBodySize === 'number' ? payload.decodedBodySize : undefined;
    // serverTime / networkTime are not in the current iframe payload but kept for forward-compat
    const serverTime = typeof payload.serverTime === 'number' ? payload.serverTime : undefined;
    const networkTime = typeof payload.networkTime === 'number' ? payload.networkTime : undefined;
    const source = $b6cbc78016fd4110$var$ACCEPTED_SOURCES.includes(payload.source) ? payload.source : undefined;
    // Base fields — always present (times are relative to interaction start from the iframe)
    const shaped = {
        label: name,
        startTime: startTime,
        duration: duration,
        workerStart: Math.max(workerStart, 0),
        fetchStart: Math.max(fetchStart, 0),
        type: initiatorType,
        ...source !== undefined ? {
            source: source
        } : {}
    };
    const cacheable = (0, $7jr5Y.isCacheableType)(rawName, initiatorType);
    shaped.ttfb = responseStart;
    if (serverTime !== undefined) shaped.serverTime = serverTime;
    if (networkTime !== undefined) shaped.networkTime = networkTime;
    if (transferSize !== undefined) shaped.size = transferSize;
    // Flag entries where timing-allow-origin headers are missing:
    // duration > 0 but all size fields are 0 means the browser withheld size data.
    if (duration > 0 && transferSize === 0 && encodedSize === 0) shaped.noTA = true;
    if (cacheable) {
        // CacheableResourceTiming — calculateTransferType is only meaningful for cacheable resources
        const transferType = (0, $7jr5Y.calculateTransferType)(rawName, initiatorType, duration, transferSize);
        if (transferType !== null) shaped.transferType = transferType;
        if (encodedSize !== undefined) shaped.encodedSize = encodedSize;
        if (decodedSize !== undefined) shaped.decodedSize = decodedSize;
    } else // NonCacheableResourceTiming (fetch, xmlhttprequest, etc.)
    shaped.requestStart = requestStart;
    return shaped;
}



var $3rKZf = parcelRequire("3rKZf");

/**
 * Iframe event shaping helpers
 *
 * These functions normalise raw Forge bridge event data into compact, consistent
 * shapes before storing in segment3pTimings, reducing payload size and aligning
 * with the equivalent host-page metrics where applicable.
 *
 * Each function receives the full raw event object (minus `type`) and returns
 * only the fields worth retaining in the analytics payload.
 */ const $bc0179c2d820c914$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
function $bc0179c2d820c914$var$extractPayload(data) {
    return data.payload !== null && typeof data.payload === 'object' ? data.payload : {};
}
function $bc0179c2d820c914$export$eb873803b57f13dd(data) {
    const payload = $bc0179c2d820c914$var$extractPayload(data);
    return {
        name: typeof payload.name === 'string' ? payload.name : '',
        startTime: $bc0179c2d820c914$var$num(payload.startTime)
    };
}
function $bc0179c2d820c914$export$249cfe420379ce6a(data) {
    const payload = $bc0179c2d820c914$var$extractPayload(data);
    return {
        startTime: $bc0179c2d820c914$var$num(payload.startTime),
        size: $bc0179c2d820c914$var$num(payload.size)
    };
}
function $bc0179c2d820c914$export$13eca0f9ce301e95(data) {
    const payload = $bc0179c2d820c914$var$extractPayload(data);
    const rawSources = Array.isArray(payload.sources) ? payload.sources : [];
    const sources = rawSources.map((source)=>{
        const s = source !== null && typeof source === 'object' ? source : {};
        return {
            node: typeof s.node === 'string' ? s.node : 'unknown'
        };
    });
    return {
        value: typeof payload.value === 'number' ? payload.value : 0,
        startTime: $bc0179c2d820c914$var$num(payload.startTime),
        cumulativeScore: typeof payload.cumulativeScore === 'number' ? payload.cumulativeScore : 0,
        sessionValue: typeof payload.sessionValue === 'number' ? payload.sessionValue : 0,
        sources: sources
    };
}
function $bc0179c2d820c914$export$e8c5a8531f7dfa04(data) {
    const payload = $bc0179c2d820c914$var$extractPayload(data);
    return payload.isFinalBatch === true;
}
function $bc0179c2d820c914$export$6954fd19623912a2(data) {
    const payload = $bc0179c2d820c914$var$extractPayload(data);
    return {
        totalMutations: typeof payload.totalMutations === 'number' ? payload.totalMutations : 0,
        observationDurationMs: $bc0179c2d820c914$var$num(payload.observationDurationMs),
        stopReason: typeof payload.stopReason === 'string' ? payload.stopReason : null
    };
}


const $ba2ad8cbeeae4634$var$FORGE_TTAI_EVENT_PREFIX = 'ufo-forge';
// Early-signal event emitted by the iframe bridge as soon as it wires up its
// UFO observers. Receiving this within ABORT_TIMEOUT_INITIAL_MS tells us the
// iframe is on the new rollout cohort and will send data events.
const $ba2ad8cbeeae4634$var$FORGE_INIT_EVENT = 'ufo-forge-init';
// Grace period (ms) after the navigation hold releases before finalising.
const $ba2ad8cbeeae4634$var$GRACE_PERIOD_MS = 2000;
// Initial abort timeout (ms from mount). If no recognised iframe event arrives within
// this window, the hold is force-released and an abort marker is logged. This protects
// metric quality during progressive rollouts where old-cohort iframes never emit events.
const $ba2ad8cbeeae4634$var$ABORT_TIMEOUT_INITIAL_MS = 6000;
// Per-segment cap on the number of `resized` entries forwarded to addIframeSegmentData.
// useResizeAnalytics already limits emissions to a 10s tracking window, but a chatty
// app could still produce dozens of resizes; combined with many Forge apps on one
// page this could push segment3pData toward the 60 KB soft limit. The cap provides
// defence-in-depth without affecting realistic apps (typical <20 resizes per segment).
const $ba2ad8cbeeae4634$var$MAX_RESIZED_ENTRIES_PER_SEGMENT = 50;
// Extended abort timeout (ms from mount). Once any recognised iframe event is received
// we know the iframe is on the new rollout cohort and actively sending data, so we extend
// the window to accommodate legitimately slow-loading Forge apps.
const $ba2ad8cbeeae4634$var$ABORT_TIMEOUT_EXTENDED_MS = 30000;
// Events logged via addIframeSegmentData as they arrive.
const $ba2ad8cbeeae4634$var$IFRAME_SEGMENT_DATA_SUFFIXES = [
    'resource-timing',
    'paint-timing',
    'largest-contentful-paint',
    'layout-shift',
    'dom-mutations',
    'navigation-timing'
];
// Events that extend the forge-ui-requests corrected end-time during grace.
const $ba2ad8cbeeae4634$var$NAV_HOLD_GRACE_SUFFIXES = new Set([
    'navigation-timing',
    'resource-timing'
]);
/** Reads segmentId from UFOInteractionContext and stores it in a ref. */ function $ba2ad8cbeeae4634$var$IframeSegmentIdReader({ segmentIdRef: segmentIdRef }) {
    const context = (0, $42omo.useContext)((0, $9x4nt.default));
    const labelStack = context?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
/** Subscribes to iframe performance events and records them as segment3pTimings. */ function $ba2ad8cbeeae4634$var$IframeSegment({ onRegisterIframeEventListener: onRegisterIframeEventListener, appType: appType }) {
    const interactionId = (0, $42omo.useContext)((0, $feexy.default));
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const segmentIdRef = (0, $42omo.useRef)(undefined);
    // Per-segment counter for `resized` entries (defence-in-depth payload cap).
    // Tracks both the count AND the segmentId it was last incremented under, so
    // SPA navigations that swap segmentId reset the budget for the new segment.
    const resizedCountRef = (0, $42omo.useRef)(0);
    const resizedCounterSegmentIdRef = (0, $42omo.useRef)(undefined);
    const isUiKit = appType === 'UIKit';
    // Released on the first navigation-timing event from the iframe.
    const [navigationHold, setNavigationHold] = (0, $42omo.useState)('holding');
    // UIKit: wrap onRender to account for React Profiler timings
    // Accumulates profiler timing bounds so we emit one aggregated entry at cleanup.
    const profilerAccRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isUiKit || !interactionContext || !interactionContext.onRender) return;
        const originalOnRender = interactionContext.onRender.bind(interactionContext);
        interactionContext.onRender = function(phase, actualDuration, baseDuration, startTime, commitTime) {
            originalOnRender(phase, actualDuration, baseDuration, startTime, commitTime);
            // Accumulate timing bounds into a single entry.
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            if (profilerAccRef.current === null) profilerAccRef.current = {
                startTime: start,
                endTime: end
            };
            else {
                if (start < profilerAccRef.current.startTime) profilerAccRef.current.startTime = start;
                if (end > profilerAccRef.current.endTime) profilerAccRef.current.endTime = end;
            }
        };
        return ()=>{
            interactionContext.onRender = originalOnRender;
        };
    }, [
        isUiKit,
        interactionContext,
        interactionId
    ]);
    (0, $42omo.useEffect)(()=>{
        let navigationHoldReleased = false;
        let lastNavEventTime = null;
        let gracePeriodTimer = null;
        // Tracks whether any recognised iframe event has been received, which tells us
        // the iframe is on the new rollout cohort and actively sending data.
        let iframeEventsReceived = false;
        let abortTimer;
        const mountTime = performance.now();
        const fireAbort = (abortAfterMs)=>{
            // Cancel any pending grace period so it doesn't also fire.
            if (gracePeriodTimer !== null) {
                clearTimeout(gracePeriodTimer);
                gracePeriodTimer = null;
            }
            // Force-release the hold if still active at abort time.
            if (!navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
            }
            // Record the abort marker so downstream analytics can detect it.
            if (interactionId.current && segmentIdRef.current) (0, $4u5NT.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                label: 'segment-timing-abort',
                data: {
                    reason: 'timeout',
                    abortAfterMs: abortAfterMs
                }
            });
        };
        // Start with the short initial timeout. If no ufo-forge-init signal arrives
        // within this window, the iframe is likely an old-cohort app that will never
        // send events — abort early to avoid blocking the interaction indefinitely.
        abortTimer = setTimeout(()=>{
            if (!iframeEventsReceived) fireAbort($ba2ad8cbeeae4634$var$ABORT_TIMEOUT_INITIAL_MS);
        }, $ba2ad8cbeeae4634$var$ABORT_TIMEOUT_INITIAL_MS);
        const finaliseHolds = ()=>{
            const iid = interactionId.current;
            const lStack = interactionContext?.labelStack;
            if (iid && lStack) {
                if (lastNavEventTime !== null) (0, $4u5NT.addCompletedHold)(iid, lStack, 'forge-ui-requests', mountTime, lastNavEventTime);
            }
        };
        const scheduleGracePeriodExpiry = ()=>{
            // Reset the 2s countdown each time a new event arrives during the grace period.
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
            gracePeriodTimer = setTimeout(()=>{
                clearTimeout(abortTimer);
                finaliseHolds();
            }, $ba2ad8cbeeae4634$var$GRACE_PERIOD_MS);
        };
        const maybeStartGracePeriod = ()=>{
            if (navigationHoldReleased && gracePeriodTimer === null) scheduleGracePeriodExpiry();
        };
        const handleEvent = (event)=>{
            // Host-side `resized` events come from useResizeAnalytics (forge-ui).
            // They are emitted whenever the iframe container height changes during
            // the 10s tracking window after mount. We forward only the reliable
            // fields (height, elapsed). The `measuredHeight` and `viewportHeight`
            // fields are intentionally excluded because they require a vendor
            // config that is rarely populated in practice (almost always null).
            if (event.type === 'resized') {
                // Gated by feature flag. When OFF, host-side `resized` events are
                // ignored entirely so segment3pData and the abort timer behave as if
                // this code path did not exist.
                if (!(0, $dh538.fg)('platform_ufo_3p_segment_resize_event')) return;
                // Guard against malformed payloads (height is required and must be
                // a non-negative number; useResizeAnalytics emits Math.trunc'd ints).
                // `IframeSegmentEvent` already declares `[key: string]: unknown`, so
                // no `as` cast is needed — the typeof guards handle runtime safety.
                const { height: height, elapsed: elapsed } = event;
                // Reset the per-segment counter when the active segmentId changes
                // (SPA navigations swap segments; each gets a fresh budget).
                if (segmentIdRef.current && segmentIdRef.current !== resizedCounterSegmentIdRef.current) {
                    resizedCountRef.current = 0;
                    resizedCounterSegmentIdRef.current = segmentIdRef.current;
                }
                if (typeof height === 'number' && Number.isFinite(height) && height >= 0 && typeof elapsed === 'number' && Number.isFinite(elapsed) && elapsed >= 0 && resizedCountRef.current < $ba2ad8cbeeae4634$var$MAX_RESIZED_ENTRIES_PER_SEGMENT && interactionId.current && segmentIdRef.current) {
                    resizedCountRef.current += 1;
                    (0, $4u5NT.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                        label: 'resized',
                        data: {
                            height: height,
                            elapsed: elapsed
                        }
                    });
                }
                // NOTE: we deliberately do NOT set iframeEventsReceived = true here.
                // The 6s abort timer exists to detect old-cohort iframes that won't
                // emit bridge events. `resized` is a host-side signal (forge-ui's
                // ResizeObserver) and fires regardless of which bridge version the
                // iframe is serving, so it cannot confirm new-cohort membership.
                // Only bridge-emitted `ufo-forge-*` events (esp. `ufo-forge-init`)
                // are valid proof, and they extend the abort timeout below.
                return;
            }
            if (event.type !== 'ufo-event' || typeof event.name !== 'string' || !event.name.startsWith($ba2ad8cbeeae4634$var$FORGE_TTAI_EVENT_PREFIX)) return;
            const eventName = event.name;
            const suffix = $ba2ad8cbeeae4634$var$IFRAME_SEGMENT_DATA_SUFFIXES.find((s)=>eventName.endsWith(`-${s}`));
            if (suffix && interactionId.current && segmentIdRef.current) {
                const { type: type, ...rest } = event;
                const restData = rest;
                let data;
                if (suffix === 'resource-timing') data = (0, $b6cbc78016fd4110$export$58bcddf582fad063)(restData);
                else if (suffix === 'navigation-timing') data = (0, $b6cbc78016fd4110$export$545c2c69328f5019)(restData);
                else if (suffix === 'paint-timing') data = (0, $bc0179c2d820c914$export$eb873803b57f13dd)(restData);
                else if (suffix === 'largest-contentful-paint') data = (0, $bc0179c2d820c914$export$249cfe420379ce6a)(restData);
                else if (suffix === 'layout-shift') data = (0, $bc0179c2d820c914$export$13eca0f9ce301e95)(restData);
                else if (suffix === 'dom-mutations') {
                    // Skip intermediate batches — only record the final summary batch.
                    if (!(0, $bc0179c2d820c914$export$e8c5a8531f7dfa04)(restData)) return;
                    data = (0, $bc0179c2d820c914$export$6954fd19623912a2)(restData);
                } else data = restData;
                (0, $4u5NT.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: suffix,
                    data: data
                });
            }
            // ufo-forge-init confirms the iframe is on the new rollout cohort — extend the abort window.
            if (eventName === $ba2ad8cbeeae4634$var$FORGE_INIT_EVENT && !iframeEventsReceived) {
                iframeEventsReceived = true;
                clearTimeout(abortTimer);
                const remainingMs = Math.max($ba2ad8cbeeae4634$var$ABORT_TIMEOUT_EXTENDED_MS - (performance.now() - mountTime), 0);
                abortTimer = setTimeout(()=>{
                    fireAbort($ba2ad8cbeeae4634$var$ABORT_TIMEOUT_EXTENDED_MS);
                }, remainingMs);
            }
            if (eventName.endsWith('-navigation-timing') && !navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
                maybeStartGracePeriod();
            }
            if (navigationHoldReleased) {
                const now = performance.now();
                if (suffix && $ba2ad8cbeeae4634$var$NAV_HOLD_GRACE_SUFFIXES.has(suffix)) {
                    lastNavEventTime = now;
                    scheduleGracePeriodExpiry();
                }
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        // Emit react-profiler-timing for UI kit
        const activeInteraction = (0, $4u5NT.getActiveInteraction)();
        let isUnmounted = false;
        if (activeInteraction) activeInteraction.cleanupCallbacks.push(()=>{
            if (isUnmounted) return;
            const iid = interactionId.current;
            const sid = segmentIdRef.current;
            if (iid && sid && profilerAccRef.current !== null) {
                (0, $4u5NT.addIframeSegmentData)(iid, sid, {
                    label: 'react-profiler-timing',
                    data: {
                        ...profilerAccRef.current
                    }
                });
                profilerAccRef.current = null;
            }
        });
        return ()=>{
            isUnmounted = true;
            unregister();
            clearTimeout(abortTimer);
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
        };
    }, [
        onRegisterIframeEventListener,
        interactionId,
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $atuQf.default), {
        name: "forge-ui-requests",
        hold: navigationHold === 'holding'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ad8cbeeae4634$var$IframeSegmentIdReader, {
        segmentIdRef: segmentIdRef
    }));
}
/** Writes per-segment extraData via addSegmentExtraData. */ function $ba2ad8cbeeae4634$var$SegmentExtraDataWriter({ extraData: extraData }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const interactionId = (0, $42omo.useContext)((0, $feexy.default));
    const labelStack = interactionContext?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, $42omo.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, $4u5NT.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
    }, [
        extraData,
        segmentId,
        interactionId
    ]);
    return null;
}
const $ba2ad8cbeeae4634$export$5f6fe75c46d0124e = (props)=>{
    const { children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, extraData: extraData, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3rKZf.default), {
        type: "third-party",
        ...otherProps
    }, onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ad8cbeeae4634$var$IframeSegment, {
        onRegisterIframeEventListener: onRegisterIframeEventListener,
        appType: extraData.appType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ad8cbeeae4634$var$SegmentExtraDataWriter, {
        extraData: extraData
    })), children);
};
$ba2ad8cbeeae4634$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';
module.exports["UFOThirdPartySegment"] = $ba2ad8cbeeae4634$export$5f6fe75c46d0124e;

});

parcelRegister("7jr5Y", function(module, exports) {
const $215a07031afc27e6$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $215a07031afc27e6$var$CACHE_NETWORK = 'network';
const $215a07031afc27e6$var$CACHE_MEMORY = 'memory';
const $215a07031afc27e6$var$CACHE_DISK = 'disk';
function $215a07031afc27e6$export$86a03f39f85a653c(url, type) {
    if ($215a07031afc27e6$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
function $215a07031afc27e6$export$82deef6698791e4e(name, type, duration, size) {
    if (!$215a07031afc27e6$export$86a03f39f85a653c(name, type)) return $215a07031afc27e6$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $215a07031afc27e6$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $215a07031afc27e6$var$CACHE_DISK;
    if (size === undefined) return null;
    return $215a07031afc27e6$var$CACHE_NETWORK;
}
module.exports["isCacheableType"] = $215a07031afc27e6$export$86a03f39f85a653c;
module.exports["calculateTransferType"] = $215a07031afc27e6$export$82deef6698791e4e;

});

parcelRegister("054Kg", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $lMdlY = parcelRequire("lMdlY");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");


var $ic4nn = parcelRequire("ic4nn");

const $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $0c6d94f33ca9a8a9$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $53d5Q.isUFOEnabled)()) return;
    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $ic4nn.default).current = routeName || null;
    const rate = ufoName ? (0, $53d5Q.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $1haRI.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $dQl1W.v4)();
        (0, $feexy.DefaultInteractionID).current = newId;
        (0, $4u5NT.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $lMdlY.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $4u5NT.addHoldByID)(newId, [], $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME, $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $4u5NT.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $4u5NT.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $4u5NT.removeHoldByID)(activeInteraction.id, $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME);
    }
}
var $0c6d94f33ca9a8a9$export$2e2bcd8739ae039 = $0c6d94f33ca9a8a9$var$traceUFOPageLoad;
function $0c6d94f33ca9a8a9$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $53d5Q.isUFOEnabled)()) return;
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $53d5Q.getInteractionRate)(ufoName, 'page_load');
        (0, $4u5NT.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $1haRI.default)(rate)) (0, $ic4nn.default).current = ufoName;
        else (0, $4u5NT.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $4u5NT.removeHoldByID)(interaction.id, $0c6d94f33ca9a8a9$var$AWAITING_PAGELOAD_NAME);
}
module.exports["default"] = $0c6d94f33ca9a8a9$export$2e2bcd8739ae039;
module.exports["updatePageloadName"] = $0c6d94f33ca9a8a9$export$d0f99433cd4f4028;

});

parcelRegister("lrb5W", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

function $591692b919e385db$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0) {
    (0, $4u5NT.addSpanToAll)('custom', name, [
        {
            name: 'custom'
        }
    ], start, end, size);
}
module.exports["addCustomSpans"] = $591692b919e385db$export$5342dcad19138a1c;

});

parcelRegister("fwDOR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a731ba177520a45$export$2e2bcd8739ae039);

var $atuQf = parcelRequire("atuQf");

var $2a731ba177520a45$export$2e2bcd8739ae039 = (0, $atuQf.default);

});

parcelRegister("4TXTZ", function(module, exports) {

var $fTvzg = parcelRequire("fTvzg");

function $89d8cfd6b25635d5$var$traceUFOPress(name, timestamp) {
    return (0, $fTvzg.default)(name, 'press', timestamp);
}
var $89d8cfd6b25635d5$export$2e2bcd8739ae039 = $89d8cfd6b25635d5$var$traceUFOPress;
module.exports["default"] = $89d8cfd6b25635d5$export$2e2bcd8739ae039;

});

parcelRegister("fTvzg", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $lMdlY = parcelRequire("lMdlY");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");


var $ic4nn = parcelRequire("ic4nn");

function $f6fe215727711212$var$traceUFOInteraction(name, interactionType, startTime) {
    if (!(0, $53d5Q.isUFOEnabled)()) return;
    const rate = (0, $53d5Q.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $53d5Q.getDoNotAbortActivePressInteraction)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $53d5Q.getMinorInteractions)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $4u5NT.getActiveInteraction)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $4u5NT.abortAll)('new_interaction', name);
    if ((0, $1haRI.default)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $dQl1W.v4)();
        (0, $feexy.DefaultInteractionID).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $lMdlY.setInteractionActiveTrace)(newId, interactionType);
        (0, $4u5NT.addNewInteraction)(newId, name, interactionType === 'hover' ? 'press' : interactionType, startTimestamp, rate, [], (0, $ic4nn.default).current, (0, $lMdlY.getActiveTrace)());
    }
}
var $f6fe215727711212$export$2e2bcd8739ae039 = $f6fe215727711212$var$traceUFOInteraction;
module.exports["default"] = $f6fe215727711212$export$2e2bcd8739ae039;

});

parcelRegister("6T8v4", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eWRwJ = parcelRequire("eWRwJ");

var $ggbZE = parcelRequire("ggbZE");

var $1DWH0 = parcelRequire("1DWH0");


var $dLFFJ = parcelRequire("dLFFJ");

const $07363c6062dac82b$var$packageName = "platform-pkg";
const $07363c6062dac82b$var$packageVersion = "0.0.0-use.local";
const $07363c6062dac82b$var$createAndFireEventOnAtlaskit = (0, $eWRwJ.default)('atlaskit');
const $07363c6062dac82b$var$Select = (0, $ggbZE.default)({
    componentName: 'select',
    packageName: $07363c6062dac82b$var$packageName,
    packageVersion: $07363c6062dac82b$var$packageVersion
})((0, $1DWH0.default)({
    onChange: $07363c6062dac82b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $07363c6062dac82b$var$packageName,
            packageVersion: $07363c6062dac82b$var$packageVersion
        }
    })
})((0, $dLFFJ.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$07363c6062dac82b$export$2e2bcd8739ae039 = $07363c6062dac82b$var$Select;
module.exports["default"] = $07363c6062dac82b$export$2e2bcd8739ae039;

});

parcelRegister("dLFFJ", function(module, exports) {

var $9tehW = parcelRequire("9tehW");


var $2KLMV = parcelRequire("2KLMV");

const $8e82a6ffcec0d69c$export$d1de3b251ccaa8a3 = (0, $2KLMV.default)((0, $9tehW.default));
module.exports["SelectWithoutAnalytics"] = $8e82a6ffcec0d69c$export$d1de3b251ccaa8a3;

});

parcelRegister("2KLMV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6a97b9745d65e5f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $f6a97b9745d65e5f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $42omo.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $42omo.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $42omo.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});

parcelRegister("cbc8g", function(module, exports) {
$parcel$export(module.exports, "default", () => $0483100954c0c407$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $0483100954c0c407$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $0483100954c0c407$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $4u5NT.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $4u5NT.addCustomData)(currentInteractionId, [], data);
}
module.exports["addUFOCustomData"] = $0483100954c0c407$export$d12f56a472cdbe6c;

});

parcelRegister("lxDfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cc643ba9c6660e6$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");

/**
 * Annotate part of the react tree with a product name
 * ```
 * <UFOLabel name="card">
 *   <Card card={data} />
 * </UFOLabel>
 * ```
 */ const $10479d7686df2fbe$var$UFOLabel = ({ name: name, children: children })=>{
    const context = (0, $9x4nt.useInteractionContext)();
    const newContext = (0, $42omo.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x4nt.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
$10479d7686df2fbe$var$UFOLabel.displayName = 'UFOLabel';
var $10479d7686df2fbe$export$2e2bcd8739ae039 = $10479d7686df2fbe$var$UFOLabel;


var $8cc643ba9c6660e6$export$2e2bcd8739ae039 = (0, $10479d7686df2fbe$export$2e2bcd8739ae039);

});

parcelRegister("b1Jpy", function(module, exports) {
$parcel$export(module.exports, "default", () => $23a47fcdab208eaa$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");





var $90YwQ = parcelRequire("90YwQ");

/**
 * Prevent a subtree from holding up an interaction
 * Use this when you have a component which loads in late, but
 * isn't considered to be a breach of SLO
 *
 * ```js
 * <App>
 *   <Main />
 *   <Sidebar>
 *     <UFOIgnoreHolds>
 *       <InsightsButton />
 *     </UFOIgnoreHolds>
 *   </Sidebar>
 * </App>
 * ```
 *
 * Has an `ignore` prop, to allow you to use it conditionally
 * Has a `reason` prop, to specify why the hold is being ignored
 */ const $6e84f86070e7284b$var$UFOIgnoreHolds = ({ children: children, ignore: ignore = true })=>{
    const parentContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const ignoredInteractionContext = (0, $42omo.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90YwQ.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
};
$6e84f86070e7284b$var$UFOIgnoreHolds.displayName = 'UFOIgnoreHolds';
var $6e84f86070e7284b$export$2e2bcd8739ae039 = $6e84f86070e7284b$var$UFOIgnoreHolds;


function $23a47fcdab208eaa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e84f86070e7284b$export$2e2bcd8739ae039), props);
}

});

parcelRegister("2SlZp", function(module, exports) {
/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3scmi = parcelRequire("3scmi");


var $7p5xt = parcelRequire("7p5xt");

const $6177498a0a716491$var$baseStyles = null; /**
                          * __Menu group__
                          *
                          * A menu group includes all the actions or items in a menu.
                          *
                          * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
                          * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                          */ 
const $6177498a0a716491$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ $42omo.createElement((0, $3scmi.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $42omo.createElement((0, $7p5xt.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $gMc0m.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel,
        ...rest
    })));
var $6177498a0a716491$export$2e2bcd8739ae039 = $6177498a0a716491$var$MenuGroup;
module.exports["default"] = $6177498a0a716491$export$2e2bcd8739ae039;

});

parcelRegister("7p5xt", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d300ee48569b58ef$export$9ca534b70725964d = /*#__PURE__*/ (0, $42omo.createContext)('border');
module.exports["SELECTION_STYLE_CONTEXT_DO_NOT_USE"] = $d300ee48569b58ef$export$9ca534b70725964d;

});

parcelRegister("56M4r", function(module, exports) {
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $90YwQ = parcelRequire("90YwQ");


var $3vvFd = parcelRequire("3vvFd");

const $dd510feeaa1defc2$var$ButtonItem = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $3vvFd.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ $42omo.createElement("button", {
            "data-testid": testId,
            // which are already being passed to the button element.
            "aria-current": isSelected ? 'true' : undefined,
            ...rest,
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $dd510feeaa1defc2$export$2e2bcd8739ae039 = $dd510feeaa1defc2$var$ButtonItem;
module.exports["default"] = $dd510feeaa1defc2$export$2e2bcd8739ae039;

});

parcelRegister("d77M1", function(module, exports) {
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $90YwQ = parcelRequire("90YwQ");


var $3vvFd = parcelRequire("3vvFd");

const $ce8279f3e10e6199$var$preventEvent = (e)=>{
    e.preventDefault();
}; // Dirty hack to get generics working with forward ref [1/2]
const $ce8279f3e10e6199$var$CustomItem = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $42omo.createElement((0, $3vvFd.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ $42omo.createElement(Component, {
            "data-testid": testId,
            ...rest,
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $ce8279f3e10e6199$var$preventEvent
            },
            onMouseDown: isDisabled ? $ce8279f3e10e6199$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $ce8279f3e10e6199$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $ce8279f3e10e6199$export$2e2bcd8739ae039 = $ce8279f3e10e6199$var$CustomItem;
module.exports["default"] = $ce8279f3e10e6199$export$2e2bcd8739ae039;

});

parcelRegister("cGtPE", function(module, exports) {
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $6i41U = parcelRequire("6i41U");


var $90YwQ = parcelRequire("90YwQ");


var $3vvFd = parcelRequire("3vvFd");

const $9426f8a418a333b3$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $9426f8a418a333b3$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $9426f8a418a333b3$var$preventEvent = (e)=>{
    e.preventDefault();
}; /**
    * __Link item__
    *
    * A link item is used to populate a menu with items that are links.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
    */ 
const $9426f8a418a333b3$var$LinkItem = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $6i41U.default)();
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $9426f8a418a333b3$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $9426f8a418a333b3$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === ''; /**
                                                    * Renders a router link if:
                                                    *
                                                    * - a link component is set in the app provider
                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
                                                    * - it doesn't have an empty href (e.g. href="" or href={undefined})
                                                    */ 
    const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $42omo.createElement((0, $3vvFd.default), {
        ...rest,
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ $42omo.createElement(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item",
            ...rest,
            className: className,
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $9426f8a418a333b3$var$preventEvent
            },
            onMouseDown: isDisabled ? $9426f8a418a333b3$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $9426f8a418a333b3$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $9426f8a418a333b3$export$2e2bcd8739ae039 = $9426f8a418a333b3$var$LinkItem;
module.exports["default"] = $9426f8a418a333b3$export$2e2bcd8739ae039;

});

parcelRegister("7rvPL", function(module, exports) {
/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gBbsI = parcelRequire("gBbsI");

const $3d092607412362b0$var$itemHeadingTopMargin = 20;
const $3d092607412362b0$var$itemHeadingBottomMargin = 6; // Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $3d092607412362b0$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $3d092607412362b0$var$skeletonHeadingHeight = 8;
const $3d092607412362b0$var$skeletonHeadingMarginOffset = 3;
const $3d092607412362b0$var$skeletonHeadingTopMargin = $3d092607412362b0$var$itemHeadingTopMargin + ($3d092607412362b0$var$itemHeadingContentHeight - $3d092607412362b0$var$skeletonHeadingHeight) - $3d092607412362b0$var$skeletonHeadingMarginOffset;
const $3d092607412362b0$var$sectionPaddingTopBottom = 6;
const $3d092607412362b0$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
}; /**
    * __Section__
    *
    * A section includes related actions or items in a menu.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
    */ 
const $3d092607412362b0$var$Section = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ $42omo.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $42omo.Children).map((0, $42omo.Children).toArray(children), (child, index)=>/*#__PURE__*/ $42omo.createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $gBbsI.default), {
        testId: testId && `${testId}--heading`,
        "aria-hidden": true,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $gMc0m.default)([
            isSideNavSection && $3d092607412362b0$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, content);
    return /*#__PURE__*/ $42omo.createElement("div", {
        ...rest,
        className: (0, $gMc0m.default)([
            $3d092607412362b0$var$styles.root,
            isScrollable ? $3d092607412362b0$var$styles.scrollable : $3d092607412362b0$var$styles.unscrollable,
            hasSeparator ? $3d092607412362b0$var$styles.thinSeparator : $3d092607412362b0$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $3d092607412362b0$export$2e2bcd8739ae039 = $3d092607412362b0$var$Section;
module.exports["default"] = $3d092607412362b0$export$2e2bcd8739ae039;

});

parcelRegister("gBbsI", function(module, exports) {
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0d2784ee49e777dc$var$headingStyles = null; /**
                             * __Heading item__
                             *
                             * A heading item is used to describe sibling menu items.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $0d2784ee49e777dc$var$HeadingItem = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $gMc0m.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest
    }, children);
});
var $0d2784ee49e777dc$export$2e2bcd8739ae039 = $0d2784ee49e777dc$var$HeadingItem;
module.exports["default"] = $0d2784ee49e777dc$export$2e2bcd8739ae039;

});

parcelRegister("kGwvc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $ea28cde92ae36f5d$export$2e2bcd8739ae039({ name: name, timestamp: timestamp }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (interactionContext != null) interactionContext.addMark(name, timestamp);
    }, [
        interactionContext,
        name,
        timestamp
    ]);
    return null;
}
function $ea28cde92ae36f5d$export$dab235c4bc5af006({ data: data }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (interactionContext != null && data != null) Object.keys(data).forEach((i)=>{
            interactionContext.addMark(i, data[i]);
        });
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $ea28cde92ae36f5d$export$f60090ba91e71358(name, timestamp) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const time = timestamp || performance.now();
    (0, $4u5NT.addMark)(currentInteractionId, 'custom', name, [], time);
}
module.exports["addUFOCustomMark"] = $ea28cde92ae36f5d$export$f60090ba91e71358;

});

parcelRegister("bniL1", function(module, exports) {
$parcel$export(module.exports, "default", () => $daaceb6577136851$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");




const $6289dbe1fb51a9ba$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $6289dbe1fb51a9ba$var$LazySuspenseContext = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $6289dbe1fb51a9ba$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($6289dbe1fb51a9ba$var$LazySuspenseContext);
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$6289dbe1fb51a9ba$var$DynamicFallback.displayName = 'DynamicFallback';
const $6289dbe1fb51a9ba$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $42omo.useState)(null);
    const mountedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6289dbe1fb51a9ba$var$DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6289dbe1fb51a9ba$var$LazySuspenseContext.Provider, {
        value: contextValue
    }, $6289dbe1fb51a9ba$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: renderFallback(false)
    }, children), (!mountedRef.current || hydrationFallback) && renderFallback(true)));
};
$6289dbe1fb51a9ba$export$256c542058532d6f.displayName = 'LazySuspense';




const $1b25440b482e3c89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});


function $c667fbdd4db7a90b$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $42omo.useContext)((0, $1b25440b482e3c89$export$9ba3fe09d15de47b));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6289dbe1fb51a9ba$export$256c542058532d6f), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: name,
            hold: shouldHold
        })),
        name: name
    }, children);
}


var $daaceb6577136851$export$2e2bcd8739ae039 = (0, $c667fbdd4db7a90b$export$2e2bcd8739ae039);

});

parcelRegister("eduVw", function(module, exports) {

var $9x4nt = parcelRequire("9x4nt");


var $4u5NT = parcelRequire("4u5NT");

function $922fc1eac6db4ea5$export$75d40f522062f923() {
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $4u5NT.getActiveInteraction)();
        if (interaction?.id) (0, $4u5NT.addError)(interaction.id, error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $4u5NT.addErrorToAll)(error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}
module.exports["useUFOReportError"] = $922fc1eac6db4ea5$export$75d40f522062f923;

});

parcelRegister("kpdGL", function(module, exports) {
/* avatar-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $icCPq = parcelRequire("icCPq");

const $25fb6079931f7a3a$var$bgColorCssVar = '--avatar-item-bg-color';
const $25fb6079931f7a3a$var$styles = {
    root: "_2rkofajl _12ji1r31 _1qu2glyw _12y31o36 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1h6o _bfhk1g13 _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48pi7a9 _vwz4kb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i51b66 _1q511b66 _y4ti1b66 _bozg1b66 _y3gn1e5h",
    rootDisabled: "_80om13gf _tzy42wxo _lcxvglyw",
    rootInteractive: "_nt751r31 _49pcglyw _1hvw1o36 _858u1v1w _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _d0altlke _1di6fcek",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _vwz419ii _bozgu2gc",
    baseText: "_1e0c1ule _syazi7uo",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c",
    secondaryTextLegacy: "_syaz1rpy _1wyb181o"
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $25fb6079931f7a3a$var$AvatarItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const Container = (0, $icCPq.default)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ $42omo.createElement(Container, {
        style: {
            [$25fb6079931f7a3a$var$bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $gMc0m.default)([
            $25fb6079931f7a3a$var$styles.root,
            isInteractive && $25fb6079931f7a3a$var$styles.rootInteractive,
            isDisabled && $25fb6079931f7a3a$var$styles.rootDisabled
        ])
    }, avatar, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $25fb6079931f7a3a$var$styles.avatarItem
        ])
    }, (0, $dh538.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        maxLines: isTruncationDisabled ? undefined : 1
    }, primaryText), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        maxLines: isTruncationDisabled ? undefined : 1,
        size: "small"
    }, secondaryText)) : /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $25fb6079931f7a3a$var$styles.baseText,
            !isTruncationDisabled && $25fb6079931f7a3a$var$styles.truncation
        ])
    }, primaryText), /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $25fb6079931f7a3a$var$styles.baseText,
            $25fb6079931f7a3a$var$styles.secondaryTextLegacy,
            !isTruncationDisabled && $25fb6079931f7a3a$var$styles.truncation
        ])
    }, secondaryText))));
});
$25fb6079931f7a3a$var$AvatarItem.displayName = 'AvatarItem';
var $25fb6079931f7a3a$export$2e2bcd8739ae039 = $25fb6079931f7a3a$var$AvatarItem;
module.exports["default"] = $25fb6079931f7a3a$export$2e2bcd8739ae039;

});

parcelRegister("esRft", function(module, exports) {
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $c0qxy = parcelRequire("c0qxy");


var $3wBuN = parcelRequire("3wBuN");

/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $hge3g = parcelRequire("hge3g");


var $6767u = parcelRequire("6767u");


var $5j8et = parcelRequire("5j8et");

const $d3794dd2c8574405$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
const $d3794dd2c8574405$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $d3794dd2c8574405$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $d3794dd2c8574405$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    // If src changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5j8et))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $d3794dd2c8574405$var$styles.icon,
                $d3794dd2c8574405$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $42omo.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $gMc0m.default)([
            $d3794dd2c8574405$var$styles.image,
            $d3794dd2c8574405$var$borderRadiusMap[size],
            appearance === 'circle' && $d3794dd2c8574405$var$styles.circle,
            appearance === 'hexagon' && $d3794dd2c8574405$var$styles.hexagon
        ])
    });
};
var $d3794dd2c8574405$export$2e2bcd8739ae039 = $d3794dd2c8574405$var$AvatarImage;



var $go6lE = parcelRequire("go6lE");


var $3bv9M = parcelRequire("3bv9M");


var $icCPq = parcelRequire("icCPq");

/* presence-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 


/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $4e2b759a57bad8b9$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $4e2b759a57bad8b9$var$unboundStyles = {
    root: "_1h6d1bhr"
}; /**
    * __Icon wrapper__
    *
    * An icon wrapper is used internally only.
    */ 
const $4e2b759a57bad8b9$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ $42omo.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $gMc0m.default)([
            $4e2b759a57bad8b9$var$styles.root,
            $4e2b759a57bad8b9$var$unboundStyles.root
        ])
    }, children);
var $4e2b759a57bad8b9$export$2e2bcd8739ae039 = $4e2b759a57bad8b9$var$IconWrapper;


const $32a9e69512b9b9f6$var$BusyIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const $32a9e69512b9b9f6$var$FocusIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const $32a9e69512b9b9f6$var$OfflineIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const $32a9e69512b9b9f6$var$OnlineIndicator = /*#__PURE__*/ $42omo.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $32a9e69512b9b9f6$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $32a9e69512b9b9f6$var$BusyIndicator;
        case 'focus':
            return $32a9e69512b9b9f6$var$FocusIndicator;
        case 'offline':
            return $32a9e69512b9b9f6$var$OfflineIndicator;
        case 'online':
            return $32a9e69512b9b9f6$var$OnlineIndicator;
    }
} /**
   * __Avatar presence__
   *
   * A presence shows an avatar’s availability.
   *
   * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
   * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
   * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
   */ 
const $32a9e69512b9b9f6$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ $42omo.createElement((0, $4e2b759a57bad8b9$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $42omo.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $32a9e69512b9b9f6$var$getPresence(presence)) : children);
var $32a9e69512b9b9f6$export$2e2bcd8739ae039 = $32a9e69512b9b9f6$var$AvatarPresence;


const $4c253e02bac8a85d$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $4c253e02bac8a85d$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $4c253e02bac8a85d$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $4c253e02bac8a85d$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $4c253e02bac8a85d$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
}; /**
    * __Presence wrapper__
    *
    * A presence wrapper is used internally to position presence ontop of the avatar.
    */ 
const $4c253e02bac8a85d$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $gMc0m.default)([
            $4c253e02bac8a85d$var$styles.root,
            $4c253e02bac8a85d$var$iconSizeMap[size],
            $4c253e02bac8a85d$var$circleIconOffsetMap[size],
            appearance === 'square' && $4c253e02bac8a85d$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $4c253e02bac8a85d$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $32a9e69512b9b9f6$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $4c253e02bac8a85d$export$2e2bcd8739ae039 = $4c253e02bac8a85d$var$PresenceWrapper;


/* status-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 



const $a2ee2980e238292e$var$ApprovedIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const $a2ee2980e238292e$var$DeclinedIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const $a2ee2980e238292e$var$LockedIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
const $a2ee2980e238292e$var$WarningIndicator = /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $42omo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $a2ee2980e238292e$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $a2ee2980e238292e$var$ApprovedIndicator;
        case 'declined':
            return $a2ee2980e238292e$var$DeclinedIndicator;
        case 'locked':
            return $a2ee2980e238292e$var$LockedIndicator;
        case 'warning':
            return $a2ee2980e238292e$var$WarningIndicator;
    }
} /**
   * __Avatar status__
   *
   * An avatar status shows contextual information, such as if someone approves or declines something.
   *
   * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
   * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
   */ 
const $a2ee2980e238292e$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ $42omo.createElement((0, $4e2b759a57bad8b9$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $42omo.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $a2ee2980e238292e$var$getStatus(status)) : children);
var $a2ee2980e238292e$export$2e2bcd8739ae039 = $a2ee2980e238292e$var$AvatarStatus;


const $f374cb5606447bbe$var$styles = {
    root: "_kqswstnw"
};
const $f374cb5606447bbe$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $f374cb5606447bbe$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $f374cb5606447bbe$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $f374cb5606447bbe$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
const $f374cb5606447bbe$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $gMc0m.default)([
            $f374cb5606447bbe$var$styles.root,
            $f374cb5606447bbe$var$iconSizeMap[size],
            $f374cb5606447bbe$var$circleIconOffsetMap[size],
            appearance === 'square' && $f374cb5606447bbe$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $f374cb5606447bbe$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $a2ee2980e238292e$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $f374cb5606447bbe$export$2e2bcd8739ae039 = $f374cb5606447bbe$var$StatusWrapper;



var $2habY = parcelRequire("2habY");





var $gGs3F = parcelRequire("gGs3F");

const $ae8c5261ce7eca7a$export$b50b87a1c4086b23 = ()=>(0, $42omo.useContext)((0, $gGs3F.AvatarContext));


const $2b2889510bf9c6a8$var$packageName = "platform-pkg";
const $2b2889510bf9c6a8$var$packageVersion = "0.0.0-use.local";
const $2b2889510bf9c6a8$var$containerStyles = null; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $2b2889510bf9c6a8$var$Avatar = /*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', isDecorative: isDecorative = false, imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const context = (0, $ae8c5261ce7eca7a$export$b50b87a1c4086b23)();
    const size = (0, $2habY.getAvatarSize)({
        appearance: appearance,
        size: sizeProp || context?.size || 'medium'
    });
    const customPresenceNode = /*#__PURE__*/ (0, $42omo.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $42omo.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $42omo.useRef)(analyticsContext);
    const labelId = (0, $c0qxy.useId)();
    (0, $42omo.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $2b2889510bf9c6a8$var$packageName,
                packageVersion: $2b2889510bf9c6a8$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $2b2889510bf9c6a8$var$packageName,
            packageVersion: $2b2889510bf9c6a8$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $42omo.createElement((0, $3bv9M.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $42omo.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $go6lE.AvatarContentContext).Provider, {
        value: {
            as: (0, $icCPq.default)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? `${testId}--inner` : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $42omo.createElement((0, $d3794dd2c8574405$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $42omo.createElement((0, $3wBuN.AvatarContent), null)), isPresence && /*#__PURE__*/ $42omo.createElement((0, $4c253e02bac8a85d$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $42omo.createElement((0, $f374cb5606447bbe$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId && `${testId}--label`,
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$2b2889510bf9c6a8$var$Avatar.displayName = 'Avatar';
var $2b2889510bf9c6a8$export$2e2bcd8739ae039 = $2b2889510bf9c6a8$var$Avatar;
module.exports["default"] = $2b2889510bf9c6a8$export$2e2bcd8739ae039;

});

parcelRegister("3wBuN", function(module, exports) {
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $go6lE = parcelRequire("go6lE");





var $3bv9M = parcelRequire("3bv9M");

const $c9535105ca114cf8$export$7db5c57474082dd9 = ()=>{
    const context = (0, $42omo.useContext)((0, $3bv9M.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};


const $57a9574fe2326ae7$var$boxShadowCssVar = '--avatar-box-shadow';
const $57a9574fe2326ae7$var$bgColorCssVar = '--avatar-bg-color';
const $57a9574fe2326ae7$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $57a9574fe2326ae7$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v56410nl _1llweo6y"
};
const $57a9574fe2326ae7$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $57a9574fe2326ae7$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>{
    (0, $c9535105ca114cf8$export$7db5c57474082dd9)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $42omo.useContext)((0, $go6lE.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ $42omo.createElement(Container, {
        style: {
            [$57a9574fe2326ae7$var$bgColorCssVar]: borderColor,
            [$57a9574fe2326ae7$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $gMc0m.default)([
            $57a9574fe2326ae7$var$unboundStyles.root,
            (0, $dh538.fg)('avatar-custom-border') && $57a9574fe2326ae7$var$unboundStyles.rootCustomBorder,
            $57a9574fe2326ae7$var$styles.root,
            appearance === 'square' && $57a9574fe2326ae7$var$styles.square,
            appearance === 'circle' && $57a9574fe2326ae7$var$styles.circle,
            appearance === 'hexagon' && $57a9574fe2326ae7$var$unboundStyles.hexagon,
            $57a9574fe2326ae7$var$widthHeightMap[size],
            stackIndex !== undefined && $57a9574fe2326ae7$var$styles.positionRelative,
            isInteractive && !isDisabled && $57a9574fe2326ae7$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $dh538.fg)('platform-dst-motion-uplift') && $57a9574fe2326ae7$var$unboundStyles.interactiveMotion,
            isDisabled && $57a9574fe2326ae7$var$styles.disabled
        ])
    }, children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
     // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            [$57a9574fe2326ae7$var$bgColorCssVar]: borderColor,
            [$57a9574fe2326ae7$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $gMc0m.default)([
            $57a9574fe2326ae7$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $dh538.fg)('platform-dst-motion-uplift') && $57a9574fe2326ae7$var$unboundStyles.interactiveMotion
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
        className: (0, $gMc0m.default)([
            $57a9574fe2326ae7$var$unboundStyles.hexagonBorderContainer,
            (0, $dh538.fg)('avatar-custom-border') && $57a9574fe2326ae7$var$unboundStyles.hexagonBorderContainerCustomBorder
        ])
    }, renderedContent));
});
module.exports["AvatarContent"] = $57a9574fe2326ae7$export$47fbc0b44cae5559;

});

parcelRegister("2habY", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $f0cb9d0f22f34ed6$export$44b3cdebe54dff5b = 'platform_square_avatar_remove_xlarge_xxlarge_sizes';
const $f0cb9d0f22f34ed6$export$695fb564e621339a = ({ appearance: appearance, size: size })=>{
    if (appearance === 'square' && (size === 'xlarge' || size === 'xxlarge') && (0, $dh538.fg)('platform_square_avatar_remove_xlarge_xxlarge_sizes')) return 'large';
    return size;
};
module.exports["getAvatarSize"] = $f0cb9d0f22f34ed6$export$695fb564e621339a;

});

parcelRegister("gGs3F", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $05abc7b8f11aa79f$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
module.exports["AvatarContext"] = $05abc7b8f11aa79f$export$a20dad690e1279e2;

});

parcelRegister("99qsA", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $4XUIT = parcelRequire("4XUIT");


var $2KLMV = parcelRequire("2KLMV");

const $30cfe98b3231febb$var$CreatableSelect = (0, $2KLMV.default)((0, $4XUIT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$30cfe98b3231febb$export$2e2bcd8739ae039 = $30cfe98b3231febb$var$CreatableSelect;
module.exports["default"] = $30cfe98b3231febb$export$2e2bcd8739ae039;

});

parcelRegister("6Ipjn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $5zdke = parcelRequire("5zdke");


var $2xusd = parcelRequire("2xusd");

var $1K6bS = parcelRequire("1K6bS");

var $cs0ez = parcelRequire("cs0ez");


var $fPkhr = parcelRequire("fPkhr");


var $jwnhU = parcelRequire("jwnhU");


var $dh538 = parcelRequire("dh538");


var $eKXGE = parcelRequire("eKXGE");


var $6T8v4 = parcelRequire("6T8v4");

/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $jluld = parcelRequire("jluld");


var $3hOY6 = parcelRequire("3hOY6");

// Custom Components
// ==============================
const $1225fc37ee388135$var$dropdownStyles = null;
const $1225fc37ee388135$var$DropdownIndicator = ()=>/*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        color: "currentColor",
        label: ""
    }));
const $1225fc37ee388135$var$controlStyles = null;
const $1225fc37ee388135$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ $42omo.createElement("div", {
        ref: innerRef,
        className: (0, $gMc0m.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
        ...props,
        innerProps: innerProps
    })); // NOTE `props` intentionally omitted from `Fragment`
const $1225fc37ee388135$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ $42omo.createElement("div", innerProps, children);
const $1225fc37ee388135$var$ClearIndicator = (props)=>/*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).ClearIndicator, props);
const $1225fc37ee388135$var$MultiValueRemove = (props)=>/*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).MultiValueRemove, props); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $1225fc37ee388135$export$71abc632aa29e6fe = {
    Control: $1225fc37ee388135$var$Control,
    DropdownIndicator: $1225fc37ee388135$var$DropdownIndicator,
    Menu: $1225fc37ee388135$var$Menu,
    ClearIndicator: $1225fc37ee388135$var$ClearIndicator,
    MultiValueRemove: $1225fc37ee388135$var$MultiValueRemove
};









var $6F6hl = parcelRequire("6F6hl");

const $b6ee841ce270b8c0$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Control, props));


/* menu-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $b640b33a8d354d58$var$menuDialogStyles = null;
const $b640b33a8d354d58$var$menuDialogStylesT26Shape = null; /**
                                        * __Menu dialog__
                                        * Wrapper for PopupSelect component.
                                        */ 
const $b640b33a8d354d58$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        ref: ref,
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qs130s",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
        ])
    }, children);
});



var $if5rb = parcelRequire("if5rb");

function $380cf13eb4b3f3f1$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* popup-select-top-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $hFC20 = parcelRequire("hFC20");


var $bgEkj = parcelRequire("bgEkj");


var $4Mlap = parcelRequire("4Mlap");


var $4S3pg = parcelRequire("4S3pg");


var $itGS3 = parcelRequire("itGS3");


var $fjSIv = parcelRequire("fjSIv");






const $5da020995d3954cc$var$animation = (0, $hFC20.slideAndFade)(); // Styles.
const $5da020995d3954cc$var$menuDialogStyles = null;
const $5da020995d3954cc$var$menuDialogStylesT26Shape = null; /**
                                        * Top-layer implementation of PopupSelect.
                                        *
                                        * Replaces the legacy PopupSelect rendering pipeline
                                        * (react-popper + createPortal + react-focus-lock + @atlaskit/layering + z-index)
                                        * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
function $5da020995d3954cc$export$25125c0cb8e7659a({ closeMenuOnSelect: // PopupSelect-specific props.
closeMenuOnSelect = true, shouldCloseMenuOnTab: shouldCloseMenuOnTab = true, footer: footer, searchThreshold: searchThreshold = 5, maxMenuWidth: maxMenuWidth = 440, minMenuWidth: minMenuWidth = 220, maxMenuHeight: maxMenuHeight = 300, target: target, label: label, placeholder: placeholder, testId: testId, isOpen: controlledIsOpen, defaultIsOpen: defaultIsOpen, spacing: _spacing, options: options = [], isSearchable: isSearchable = true, components: consumerComponents, styles: consumerStyles, onChange: onChange, onKeyDown: onKeyDown, onOpen: // Lifecycle callbacks.
// @ts-ignore react-select unsupported props
onOpen, onClose: // @ts-ignore react-select unsupported props
onClose, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, popperProps: // No-op props in top-layer path.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
popperProps, // eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldPreventEscapePropagation: _shouldPreventEscapePropagation, // Remaining props spread to Select.
...selectProps }) {
    // State.
    const isControlled = controlledIsOpen !== undefined;
    const [internalIsOpen, setInternalIsOpen] = (0, $42omo.useState)(isControlled ? Boolean(controlledIsOpen) : Boolean(defaultIsOpen));
    const isOpen = isControlled ? Boolean(controlledIsOpen) : internalIsOpen;
    const selectRef = (0, $42omo.useRef)(null);
    const triggerRef = (0, $42omo.useRef)(null);
    const popoverRef = (0, $42omo.useRef)(null);
    const popoverId = (0, $fjSIv.usePopoverId)(); // Placement.
    const legacyPlacement = popperProps?.placement ?? 'bottom-start'; // `popup-select` historically defaulted to an `[along, away] = [0, 8]` popper offset
    // modifier; consumers can override it via `popperProps.modifiers`. Honour both here so
    // the top-layer rendering matches the legacy popper output.
    const legacyOffset = (0, $42omo.useMemo)(()=>{
        const modifiers = popperProps?.modifiers;
        const value = modifiers?.find((modifier)=>modifier?.name === 'offset')?.options?.offset;
        if (Array.isArray(value) && value.length === 2) return [
            Number(value[0]) || 0,
            Number(value[1]) || 0
        ];
        return [
            0,
            8
        ];
    }, [
        popperProps?.modifiers
    ]);
    const topLayerPlacement = (0, $42omo.useMemo)(()=>(0, $bgEkj.fromLegacyPlacement)({
            legacy: legacyPlacement,
            offset: legacyOffset
        }), [
        legacyPlacement,
        legacyOffset
    ]);
    (0, $itGS3.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }); // Merged components.
    const mergedComponents = (0, $42omo.useMemo)(()=>({
            ...(0, $1225fc37ee388135$export$71abc632aa29e6fe),
            ...consumerComponents
        }), [
        consumerComponents
    ]); // Default styles.
    const defaultStyles = (0, $42omo.useMemo)(()=>({
            groupHeading: (provided)=>({
                    ...provided,
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        }), []); // Utils.
    const getItemCount = (0, $42omo.useCallback)(()=>{
        return options.reduce((count, groupOrOption)=>{
            const group = groupOrOption;
            if (group.options) return count + group.options.length;
            return count + 1;
        }, 0);
    }, [
        options
    ]);
    const showSearchControl = isSearchable && getItemCount() > searchThreshold;
    const getMaxHeight = (0, $42omo.useCallback)(()=>{
        if (!selectRef.current) return maxMenuHeight;
        const controlRef = selectRef.current.select?.controlRef;
        const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
        return maxMenuHeight - offsetHeight;
    }, [
        maxMenuHeight,
        showSearchControl
    ]);
    const getLabel = (0, $42omo.useCallback)(()=>{
        if (label) return label;
        if (typeof placeholder === 'string') return placeholder;
        return undefined;
    }, [
        label,
        placeholder
    ]); // Open / Close.
    const open = (0, $42omo.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(true);
        onOpen?.();
        onMenuOpen?.();
    }, [
        isControlled,
        onOpen,
        onMenuOpen
    ]);
    const close = (0, $42omo.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(false);
        onClose?.();
        onMenuClose?.();
    }, [
        isControlled,
        onClose,
        onMenuClose
    ]); // Sync controlled isOpen.
    (0, $42omo.useEffect)(()=>{
        if (!isControlled) return;
        if (controlledIsOpen) {
            onOpen?.();
            onMenuOpen?.();
        } else {
            onClose?.();
            onMenuClose?.();
        } // Only react to changes in the controlled value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        controlledIsOpen
    ]); // Open the react-select menu when isOpen becomes true.
    (0, $42omo.useEffect)(()=>{
        if (isOpen && selectRef.current) selectRef.current.select?.openMenu('first');
    }, [
        isOpen
    ]); // Event Handlers.
    const handleTargetKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'ArrowDown') open();
    }, [
        open
    ]); // Open the menu when the trigger is clicked. Mirrors the legacy
    // PopupSelect target-click behavior (popup-select.tsx -> handleClick).
    // We cannot trust consumers to spread `onClick` onto the target; the
    // legacy implementation listened on a global click handler, but here
    // we attach `onClick` directly via the triggerProps spread.
    const handleTargetClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) close();
        else open();
    }, [
        isOpen,
        open,
        close
    ]); // Focus restoration on close is handled automatically by Popover
    // based on the content role (role="dialog" -> auto-restore).
    const handleOnClose = (0, $42omo.useCallback)(({ reason: _reason })=>{
        if (isControlled) {
            // For controlled mode, notify consumer but do not change internal state
            onClose?.();
            onMenuClose?.();
            return;
        }
        close();
    }, [
        close,
        isControlled,
        onClose,
        onMenuClose
    ]);
    const handleSelectChange = (0, $42omo.useCallback)((value, actionMeta)=>{
        if (closeMenuOnSelect && actionMeta.action !== 'clear') {
            close(); // Return focus to trigger after selection
            triggerRef.current?.focus();
        }
        onChange?.(value, actionMeta);
    }, [
        closeMenuOnSelect,
        close,
        onChange
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const tabEvent = event.key === 'Tab';
        if (shouldCloseMenuOnTab && tabEvent) {
            close();
            triggerRef.current?.focus();
        } // Escape closes the menu and returns focus to the trigger.
        // The browser auto-restores focus on Escape, but we close
        // explicitly here so isOpen state stays in sync with the popover.
        if (event.key === 'Escape') {
            close();
            triggerRef.current?.focus();
        }
        onKeyDown?.(event);
    }, [
        shouldCloseMenuOnTab,
        close,
        onKeyDown
    ]); // Select components.
    // Type assertion needed because defaultComponents uses concrete OptionType/boolean
    // but Select expects the generic Option/IsMulti parameters. The components are
    // structurally compatible regardless of the generic parameters.
    const selectComponentsMerged = (0, $42omo.useMemo)(()=>({
            ...mergedComponents,
            Control: showSearchControl ? mergedComponents.Control : (0, $b6ee841ce270b8c0$export$87ce933b7fc29b8c)
        }), [
        mergedComponents,
        showSearchControl
    ]);
    const getSelectRef = (0, $42omo.useCallback)((ref)=>{
        selectRef.current = ref;
    }, []);
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        onClick: handleTargetClick,
        onKeyDown: handleTargetKeyDown,
        // Maintain existing aria attribute format for backwards compatibility.
        // Should technically be 'dialog' instead of 'true', but preserving
        // legacy behavior. See go/DSP-22283
        'aria-haspopup': 'true',
        'aria-expanded': isOpen,
        // Always emit aria-controls referencing the controlled element.
        // Matches the behavior of `getAriaForTrigger` (see
        // `@atlaskit/top-layer/get-aria-for-trigger`) and aligns with the
        // WAI-ARIA spec recommendation.
        'aria-controls': popoverId,
        isOpen: isOpen
    };
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, target?.(triggerProps), /*#__PURE__*/ $42omo.createElement((0, $4Mlap.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "dialog",
        label: getLabel() ?? 'Popup select',
        isOpen: isOpen,
        onClose: handleOnClose,
        animate: $5da020995d3954cc$var$animation,
        placement: topLayerPlacement,
        testId: testId && `${testId}--content`
    }, /*#__PURE__*/ $42omo.createElement((0, $4S3pg.PopoverSurface), null, /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            maxWidth: maxMenuWidth,
            minWidth: minMenuWidth
        },
        "data-testid": testId && `${testId}--menu`,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _bfhk1bhr _16qs130s",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1mok"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6T8v4.default), {
        label: getLabel(),
        backspaceRemovesValue: false,
        controlShouldRenderValue: false,
        isClearable: false,
        tabSelectsValue: false,
        menuIsOpen: true,
        placeholder: placeholder,
        ref: getSelectRef,
        ...selectProps,
        options: options,
        isSearchable: showSearchControl,
        styles: (0, $eKXGE.mergeStyles)(defaultStyles, consumerStyles || {}),
        maxMenuHeight: getMaxHeight(),
        components: selectComponentsMerged,
        onChange: handleSelectChange,
        onKeyDown: handleKeyDown,
        testId: testId
    }), footer))));
}


const $44b2e7ed1d9fa8ae$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement); // ==============================
// Class
// ==============================
const $44b2e7ed1d9fa8ae$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $44b2e7ed1d9fa8ae$var$defaultPopperProps = {
    modifiers: $44b2e7ed1d9fa8ae$var$modifiers,
    placement: 'bottom-start'
};
const $44b2e7ed1d9fa8ae$var$isEmpty = (obj)=>Object.keys(obj).length === 0; // eslint-disable-next-line @repo/internal/react/no-class-components
class $44b2e7ed1d9fa8ae$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const newState = {}; // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$44b2e7ed1d9fa8ae$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $fPkhr.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
         // Merge consumer and default components
        const mergedComponents = {
            ...(0, $1225fc37ee388135$export$71abc632aa29e6fe),
            ...props.components
        };
        if (!(0, $fPkhr.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$44b2e7ed1d9fa8ae$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $fFa3V.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        // Top-layer rendering path: native Popover API via @atlaskit/top-layer
        if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5da020995d3954cc$export$25125c0cb8e7659a), this.props);
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2xusd.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jwnhU.IdProvider), {
            postfix: "-popup-select"
        }, ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cs0ez.Reference), null, ({ ref: ref })=>target && target({
                    isOpen: isOpen,
                    onKeyDown: this.handleTargetKeyDown,
                    ref: this.resolveTargetRef(ref),
                    // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                    // See go/DSP-22283
                    'aria-haspopup': 'true',
                    'aria-expanded': isOpen,
                    'aria-controls': isOpen ? id : undefined
                })), this.renderSelect(id))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $380cf13eb4b3f3f1$export$17baa7c95b6ba1b8), {
            isOpen: this.state.isOpen,
            onClose: this.handleOpenLayerObserverCloseSignal
        }));
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        };
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $1225fc37ee388135$export$71abc632aa29e6fe),
            mergedPopperProps: $44b2e7ed1d9fa8ae$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    if (this.props.shouldPreventEscapePropagation && (0, $dh538.fg)('platform_navx_sllv_dropdown_escape_and_focus_fix')) event.stopPropagation();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state; // appease flow
            if (!(target instanceof Element)) return;
             // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
             // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
    * Opens the popup
    *
    * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
    */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
    * Closes the popup
    *
    * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
    */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
             // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: _target, testId: testId, onMenuOpen: _onMenuOpen, onMenuClose: _onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $44b2e7ed1d9fa8ae$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $b6ee841ce270b8c0$export$87ce933b7fc29b8c)
            }; // @ts-ignore - TS7030: Not all code paths return a value - causing issues for help-center local consumption with TS 5.9.2
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1K6bS.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b640b33a8d354d58$export$c94219dad7c0e37d // There is not a limited amount of values for the widths, so they need to remain dynamic.
                ), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        ...style,
                        maxWidth: maxMenuWidth,
                        minWidth: minMenuWidth
                    },
                    "data-placement": placement,
                    id: id,
                    testId: testId,
                    ref: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5zdke.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
                    label: getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    isSearchable: showSearchControl,
                    styles: (0, $eKXGE.mergeStyles)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    testId: testId
                }), footer)));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $jTxSS.createPortal)(popper, portalDestination);
        };
        this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}
$44b2e7ed1d9fa8ae$export$2e2bcd8739ae039.defaultProps = {
    closeMenuOnSelect: true,
    shouldCloseMenuOnTab: true,
    components: {},
    maxMenuHeight: 300,
    maxMenuWidth: 440,
    minMenuWidth: 220,
    popperProps: {},
    isSearchable: true,
    searchThreshold: 5,
    styles: {},
    options: []
};
module.exports["default"] = $44b2e7ed1d9fa8ae$export$2e2bcd8739ae039;

});

parcelRegister("1wHV6", function(module, exports) {
const $f389c5f825d21df4$var$getAppearanceForAppType = (appType)=>{
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
};
var $f389c5f825d21df4$export$2e2bcd8739ae039 = $f389c5f825d21df4$var$getAppearanceForAppType;
module.exports["default"] = $f389c5f825d21df4$export$2e2bcd8739ae039;

});

parcelRegister("4A7Gn", function(module, exports) {
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $jr8gD = parcelRequire("jr8gD");


var $bC0Ky = parcelRequire("bC0Ky");

const $730186a7fc5862a5$var$baseStyles = null;
const $730186a7fc5862a5$var$tabsStyles = null;
const $730186a7fc5862a5$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $730186a7fc5862a5$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $42omo.createElement((0, $bC0Ky.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $730186a7fc5862a5$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $42omo.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $42omo.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $42omo.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $42omo.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$730186a7fc5862a5$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $730186a7fc5862a5$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$730186a7fc5862a5$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $jr8gD.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, tabPanelsWithContext));
};
var $730186a7fc5862a5$export$2e2bcd8739ae039 = $730186a7fc5862a5$var$Tabs;
module.exports["default"] = $730186a7fc5862a5$export$2e2bcd8739ae039;

});

parcelRegister("gCbPZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1HnpQ = parcelRequire("1HnpQ");

var $iXCQx = parcelRequire("iXCQx");


var $bDrnk = parcelRequire("bDrnk");

/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $3b870b1457200e8a$var$Tab = /*#__PURE__*/ (0, $42omo.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $bDrnk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children));
});
var $3b870b1457200e8a$export$2e2bcd8739ae039 = $3b870b1457200e8a$var$Tab;
module.exports["default"] = $3b870b1457200e8a$export$2e2bcd8739ae039;

});

parcelRegister("bDrnk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f9b83658edfa6bd$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $b4btP = parcelRequire("b4btP");

function $7f9b83658edfa6bd$export$2e2bcd8739ae039() {
    const tabData = (0, $42omo.useContext)((0, $b4btP.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
}

});

parcelRegister("0DTaW", function(module, exports) {
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $b4btP = parcelRequire("b4btP");





var $jr8gD = parcelRequire("jr8gD");

function $8924180aa47a031a$export$2e2bcd8739ae039() {
    const tabListData = (0, $42omo.useContext)((0, $jr8gD.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
}


const $4ada70430d7deb88$var$baseStyles = null;
const $4ada70430d7deb88$var$tabListStyles = null; /**
                             * __TabList__
                             *
                             * A TabList groups `Tab` components together.
                             *
                             * - [Examples](https://atlassian.design/components/tabs/examples)
                             * - [Code](https://atlassian.design/components/tabs/code)
                             * - [Usage](https://atlassian.design/components/tabs/usage)
                             */ 
const $4ada70430d7deb88$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $8924180aa47a031a$export$2e2bcd8739ae039)();
    const ref = /*#__PURE__*/ (0, $42omo.createRef)(); // Don't include any conditional children
    const childrenArray = (0, $42omo.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $42omo.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
         // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        } // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $42omo.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ $42omo.createElement((0, $b4btP.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "tablist",
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _qwyt1qi0 _7hip15vq _1fud15vq _bb0mh2mm _1quzazsu _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu1uh4 _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazazsu _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d1uh4 _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i20i7uo _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzz0c1 _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem6x5g _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rus1l7x _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ])
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        })));
};
var $4ada70430d7deb88$export$2e2bcd8739ae039 = $4ada70430d7deb88$var$TabList;
module.exports["default"] = $4ada70430d7deb88$export$2e2bcd8739ae039;

});

parcelRegister("i3GYc", function(module, exports) {
$parcel$export(module.exports, "default", () => $54c95cd234b102af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $bC0Ky = parcelRequire("bC0Ky");

function $54c95cd234b102af$export$2e2bcd8739ae039() {
    const tabPanelData = (0, $42omo.useContext)((0, $bC0Ky.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
}

});

parcelRegister("gvKQF", function(module, exports) {
const $ae28be5bd98dc6f5$export$9a270941bcff7e77 = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
module.exports["AVATAR_SIZES"] = $ae28be5bd98dc6f5$export$9a270941bcff7e77;

});

parcelRegister("1pSma", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e9db970d03f2cb5$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $90YwQ = parcelRequire("90YwQ");

function $1e9db970d03f2cb5$export$2e2bcd8739ae039(name) {
    const context = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("i4C2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $65e5ee075adb47c4$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");

const $9fd2d2634ee6589b$var$Suspense = ({ children: children, fallback: fallback, interactionName: interactionName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: interactionName
        }, fallback)
    }, children);
};
var $9fd2d2634ee6589b$export$2e2bcd8739ae039 = $9fd2d2634ee6589b$var$Suspense;


var $65e5ee075adb47c4$export$2e2bcd8739ae039 = (0, $9fd2d2634ee6589b$export$2e2bcd8739ae039);

});

parcelRegister("6eGYE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $lMdlY = parcelRequire("lMdlY");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");


var $ic4nn = parcelRequire("ic4nn");




function $4c0de59d7e455996$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}


function $e39721b2151f3953$export$f2e521e495a88544(newId) {
    (0, $lMdlY.setActiveTrace)(newId.replace(/-/g, ''), (0, $4c0de59d7e455996$export$295213bc4d0c54ad)(), 'transition');
}


function $aa51124acf13a996$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $53d5Q.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $53d5Q.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $4u5NT.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $ic4nn.default).current = ufoName;
        const rate = (0, $53d5Q.getInteractionRate)(ufoName, 'transition');
        if ((0, $1haRI.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $dQl1W.v4)();
            (0, $e39721b2151f3953$export$f2e521e495a88544)(newId);
            (0, $feexy.DefaultInteractionID).current = newId;
            (0, $4u5NT.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $lMdlY.getActiveTrace)());
        }
    }
}
function $aa51124acf13a996$export$369f0ded13ce6c50() {
    const interactionId = (0, $42omo.useContext)((0, $feexy.default));
    const capturedInteractionId = interactionId.current;
    (0, $42omo.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $4u5NT.tryComplete)(capturedInteractionId);
                });
            });
            (0, $4u5NT.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $aa51124acf13a996$export$2e2bcd8739ae039 = $aa51124acf13a996$var$traceUFOTransition;
module.exports["default"] = $aa51124acf13a996$export$2e2bcd8739ae039;

});

parcelRegister("VzzNF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $53d5Q = parcelRequire("53d5Q");


var $3AFGg = parcelRequire("3AFGg");


var $4u5NT = parcelRequire("4u5NT");


var $kyRHQ = parcelRequire("kyRHQ");

// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $cc669dc39d07f92f$var$startTimes = new Map();
const $cc669dc39d07f92f$var$spanStates = new Map();
const $cc669dc39d07f92f$export$cf4e4023c0a34c8d = ()=>{
    $cc669dc39d07f92f$var$startTimes.clear();
    $cc669dc39d07f92f$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $cc669dc39d07f92f$var$lastActiveInteraction;
function $cc669dc39d07f92f$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $4u5NT.getActiveInteraction)()?.id;
    if (!!$cc669dc39d07f92f$var$lastActiveInteraction && $cc669dc39d07f92f$var$lastActiveInteraction !== activeInteractionId) $cc669dc39d07f92f$export$cf4e4023c0a34c8d();
    $cc669dc39d07f92f$var$lastActiveInteraction = activeInteractionId;
}
const $cc669dc39d07f92f$var$getIsNativeTracingEnabled = ()=>(0, $53d5Q.getConfig)()?.ssr?.enableNativeTracing ?? false;
const $cc669dc39d07f92f$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!$cc669dc39d07f92f$var$startTimes.has(id)) $cc669dc39d07f92f$var$startTimes.set(id, []);
    $cc669dc39d07f92f$var$startTimes.get(id)?.push(performance.now());
    if (!$cc669dc39d07f92f$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = $cc669dc39d07f92f$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        $cc669dc39d07f92f$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $cc669dc39d07f92f$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $kyRHQ !== 'undefined' && Boolean($kyRHQ?.env?.REACT_SSR || false);
const $cc669dc39d07f92f$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};
const $cc669dc39d07f92f$var$ParentSpanContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $cc669dc39d07f92f$export$c8760e11c713fafc = ()=>{
    $cc669dc39d07f92f$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $cc669dc39d07f92f$var$spanStates.clear();
};
const $cc669dc39d07f92f$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $42omo.useMemo)(()=>labelStack.map((l)=>(0, $3AFGg.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $cc669dc39d07f92f$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $42omo.useContext)($cc669dc39d07f92f$var$ParentSpanContext);
    const currentSpanState = $cc669dc39d07f92f$var$onStartRender(reactProfilerId, (0, $3AFGg.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc669dc39d07f92f$var$ParentSpanContext.Provider, {
        value: currentSpanState?.span.getSpanContext() ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc669dc39d07f92f$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $cc669dc39d07f92f$var$startTimes.get(reactProfilerId);
            if (startTimesForId?.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = $cc669dc39d07f92f$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
const $cc669dc39d07f92f$var$SsrRenderProfiler = (props)=>{
    if ($cc669dc39d07f92f$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc669dc39d07f92f$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc669dc39d07f92f$var$ProfilerMarker, null), props.children);
};
var $cc669dc39d07f92f$export$2e2bcd8739ae039 = $cc669dc39d07f92f$var$SsrRenderProfiler;
module.exports["flushSsrRenderProfilerTraces"] = $cc669dc39d07f92f$export$c8760e11c713fafc;
module.exports["default"] = $cc669dc39d07f92f$export$2e2bcd8739ae039;

});

parcelRegister("liN2H", function(module, exports) {
const $a1f27f7c28cc6bf7$export$42f4885608027d0c = 'non_boolean';


function $d8474266700c35e0$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $d8474266700c35e0$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $d8474266700c35e0$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $d8474266700c35e0$export$7b4abba432e57989(value) {
    return $d8474266700c35e0$var$isString(value) && $d8474266700c35e0$var$startsAsObject(value) || $d8474266700c35e0$var$isObject(value);
}
function $d8474266700c35e0$export$fcc03ee4c944962f(featureFlagValue) {
    return $d8474266700c35e0$export$7b4abba432e57989(featureFlagValue) ? (0, $a1f27f7c28cc6bf7$export$42f4885608027d0c) : featureFlagValue;
}
module.exports["redactValue"] = $d8474266700c35e0$export$fcc03ee4c944962f;

});

parcelRegister("dV52u", function(module, exports) {
const $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $396431ece6ae946e$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $396431ece6ae946e$export$c0102f1a1198d10f {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $396431ece6ae946e$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserver = void 0;
        this.EQUALITY_THRESHOLD = 1;
        this.enablePageLayoutPlaceholder = void 0;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $396431ece6ae946e$var$PAGE_LAYOUT_ID) return $396431ece6ae946e$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $396431ece6ae946e$var$PAGE_LAYOUT_ID) return $396431ece6ae946e$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
}
module.exports["SSRPlaceholderHandlers"] = $396431ece6ae946e$export$c0102f1a1198d10f;

});

parcelRegister("IkgpF", function(module, exports) {

var $gxsT9 = parcelRequire("gxsT9");

function $32fda68705ce6e9f$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $gxsT9.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}
module.exports["isContainedWithinMediaWrapper"] = $32fda68705ce6e9f$export$f61fbc3b9c4a9019;

});

parcelRegister("10BiY", function(module, exports) {
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $01f78ad7890991d7$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $01f78ad7890991d7$export$2e2bcd8739ae039 = $01f78ad7890991d7$var$isNonVisualStyleMutation;
module.exports["default"] = $01f78ad7890991d7$export$2e2bcd8739ae039;

});

parcelRegister("hZubt", function(module, exports) {
const $bb379f9cccfc2442$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $bb379f9cccfc2442$export$166779fc0f49d4df {
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$bb379f9cccfc2442$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$bb379f9cccfc2442$var$GLOBAL_RLL_HANDLERS_KEY] = new $bb379f9cccfc2442$export$166779fc0f49d4df();
            return globalThis[$bb379f9cccfc2442$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $bb379f9cccfc2442$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
}
module.exports["RLLPlaceholderHandlers"] = $bb379f9cccfc2442$export$166779fc0f49d4df;

});

parcelRegister("3rKZf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eggFB = parcelRequire("eggFB");


var $dQl1W = parcelRequire("dQl1W");


var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $3AFGg = parcelRequire("3AFGg");


var $lMdlY = parcelRequire("lMdlY");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");


var $ic4nn = parcelRequire("ic4nn");


var $imtnZ = parcelRequire("imtnZ");


var $evSWT = parcelRequire("evSWT");


var $VzzNF = parcelRequire("VzzNF");

let $dc71afb348fff05e$var$tryCompleteHandle;
let $dc71afb348fff05e$var$hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ const $dc71afb348fff05e$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $53d5Q.isUFOEnabled)();
    const parentContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const segmentIdMap = (0, $42omo.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $42omo.useMemo)(()=>{
        if (mode === 'single') return (0, $imtnZ.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $imtnZ.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $42omo.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            } // Only pass non-default types (not 'first-party') in payload to reduce size
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $42omo.useContext)((0, $feexy.default));
    if (interactionId.current != null && !$dc71afb348fff05e$var$hasMarkedFirstSegmentLoad) {
        (0, $4u5NT.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $dc71afb348fff05e$var$hasMarkedFirstSegmentLoad = true;
    }
    const interactionContext = (0, $42omo.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($dc71afb348fff05e$var$tryCompleteHandle) cancelAnimationFrame?.($dc71afb348fff05e$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $dc71afb348fff05e$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $dc71afb348fff05e$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $4u5NT.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $4u5NT.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $eggFB.unstable_scheduleCallback)((0, $eggFB.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $4u5NT.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $4u5NT.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $4u5NT.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $53d5Q.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $53d5Q.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $4u5NT.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $4u5NT.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $53d5Q.getInteractionRate)(name, 'press');
                if ((0, $1haRI.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $dQl1W.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $lMdlY.setInteractionActiveTrace)(newId, 'press');
                    (0, $4u5NT.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $ic4nn.default).current, (0, $lMdlY.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $4u5NT.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $4u5NT.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $4u5NT.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $4u5NT.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $4u5NT.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $4u5NT.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $4u5NT.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $4u5NT.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $evSWT.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $42omo.useRef)(false);
    const onRender = (0, $42omo.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $53d5Q.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $4u5NT.addSegment)(labelStack);
        return ()=>{
            (0, $4u5NT.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $42omo.useMemo)(()=>labelStack.map((l)=>(0, $3AFGg.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x4nt.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $VzzNF.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
$dc71afb348fff05e$var$UFOSegment.displayName = 'UFOSegment';
var $dc71afb348fff05e$export$2e2bcd8739ae039 = $dc71afb348fff05e$var$UFOSegment;
module.exports["default"] = $dc71afb348fff05e$export$2e2bcd8739ae039;

});

parcelRegister("atuQf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5804b98de0d396d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $53d5Q = parcelRequire("53d5Q");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");

const $e5804b98de0d396d$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $e5804b98de0d396d$var$useInteractionIdValue() {
    const interactionId = (0, $42omo.useContext)((0, $feexy.default));
    const [currentId, setCurrentId] = (0, $42omo.useState)(interactionId?.current || null);
    $e5804b98de0d396d$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $feexy.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $e5804b98de0d396d$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $53d5Q.isUFOEnabled)();
    const currentInteractionId = $e5804b98de0d396d$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $42omo.useContext)((0, $9x4nt.default));
    $e5804b98de0d396d$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : null;
}

});

parcelRegister("3scmi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7p5xt = parcelRequire("7p5xt");

const $0edeb16950c34111$export$443076ec7ebce042 = /*#__PURE__*/ (0, $42omo.createContext)('cozy');
module.exports["SpacingContext"] = $0edeb16950c34111$export$443076ec7ebce042;

});

parcelRegister("3vvFd", function(module, exports) {
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $u9agA = parcelRequire("u9agA");


var $3scmi = parcelRequire("3scmi");


var $7p5xt = parcelRequire("7p5xt");

const $d2d7b61bf04d0548$var$renderTitle = (Component, props)=>/*#__PURE__*/ $42omo.createElement(Component, props);
const $d2d7b61bf04d0548$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g"
};
const $d2d7b61bf04d0548$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $d2d7b61bf04d0548$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
}; /**
    * __Menu item primitive__
    *
    * Menu item primitive contains all the styles for menu items,
    * including support for selected, disabled, and interaction states.
    *
    * Using children as function prop you wire up this to your own host element.
    *
    * ```jsx
    * <MenuItemPrimitive>
    *   {({ children, ...props }) => <button {...props}>{children}</button>}
    * </MenuItemPrimitive>
    * ```
    */ 
const $d2d7b61bf04d0548$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $42omo.useContext)((0, $3scmi.SpacingContext));
    const selectionStyle = (0, $42omo.useContext)((0, $7p5xt.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $gMc0m.default)([
                (0, $gMc0m.default)([
                    $d2d7b61bf04d0548$var$styles.root,
                    $d2d7b61bf04d0548$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $d2d7b61bf04d0548$var$styles.unselected,
                    !isDisabled && isSelected && $d2d7b61bf04d0548$var$styles.selected,
                    !isDisabled && isSelected && $d2d7b61bf04d0548$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $d2d7b61bf04d0548$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $d2d7b61bf04d0548$var$styles.selectedNotch,
                    isDisabled && $d2d7b61bf04d0548$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $d2d7b61bf04d0548$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ $42omo.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && `${testId}--icon-before`,
                className: (0, $gMc0m.default)([
                    $d2d7b61bf04d0548$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    $d2d7b61bf04d0548$var$styles.content
                ])
            }, $d2d7b61bf04d0548$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $gMc0m.default)([
                    $d2d7b61bf04d0548$var$styles.title,
                    shouldTitleWrap ? $d2d7b61bf04d0548$var$styles.wordBreak : $d2d7b61bf04d0548$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $42omo.createElement("span", {
                "data-item-description": true,
                className: (0, $gMc0m.default)([
                    $d2d7b61bf04d0548$var$styles.description,
                    isDisabled && $d2d7b61bf04d0548$var$styles.disabledDescription,
                    shouldDescriptionWrap && $d2d7b61bf04d0548$var$styles.wordBreak,
                    !shouldDescriptionWrap && $d2d7b61bf04d0548$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $42omo.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && `${testId}--icon-after`,
                className: (0, $gMc0m.default)([
                    $d2d7b61bf04d0548$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    })();
};
var $d2d7b61bf04d0548$export$2e2bcd8739ae039 = $d2d7b61bf04d0548$var$MenuItemPrimitive;
module.exports["default"] = $d2d7b61bf04d0548$export$2e2bcd8739ae039;

});

parcelRegister("icCPq", function(module, exports) {
const $c15cae5a29d331c6$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $c15cae5a29d331c6$export$2e2bcd8739ae039 = $c15cae5a29d331c6$var$getCustomElement;
module.exports["default"] = $c15cae5a29d331c6$export$2e2bcd8739ae039;

});

parcelRegister("go6lE", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5af44521f5c555ab$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $5af44521f5c555ab$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $42omo.createContext)($5af44521f5c555ab$var$defaultAvatarContentProps);
module.exports["AvatarContentContext"] = $5af44521f5c555ab$export$b983474ddd0b6d28;

});

parcelRegister("3bv9M", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d7458bc3b0f5ab05$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $42omo.createContext)(false);
module.exports["EnsureIsInsideAvatarContext"] = $d7458bc3b0f5ab05$export$6b4cbd90d24955ad;

});

parcelRegister("b4btP", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");

const $81243b8c3e5234a4$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["TabContext"] = $81243b8c3e5234a4$export$5a5d356ca5f10a0a;

});

parcelRegister("jr8gD", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");

const $45c303b7150c6e2b$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["TabListContext"] = $45c303b7150c6e2b$export$aa6907f9fd69e93b;

});

parcelRegister("bC0Ky", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $42omo = parcelRequire("42omo");

const $973bffe60e18b31f$export$2054129d247c3102 = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["TabPanelContext"] = $973bffe60e18b31f$export$2054129d247c3102;

});

parcelRegister("imtnZ", function(module, exports) {
function $774636daf2faf9c7$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $774636daf2faf9c7$export$2e2bcd8739ae039 = $774636daf2faf9c7$var$generateId;
module.exports["default"] = $774636daf2faf9c7$export$2e2bcd8739ae039;

});

parcelRegister("evSWT", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

function $f3c8cf0ff6b3b9e8$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.__SERVER__) || typeof $kyRHQ !== 'undefined' && Boolean($kyRHQ?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $f3c8cf0ff6b3b9e8$export$2e2bcd8739ae039 = $f3c8cf0ff6b3b9e8$var$scheduleOnPaint;
module.exports["default"] = $f3c8cf0ff6b3b9e8$export$2e2bcd8739ae039;

});


$parcel$global.rlb("7EorR")
//# sourceMappingURL=vendors~editor_atlaskit_md.fb42ebcb.js.map
